import {
  ClientDashboardModule,
  ClientModule,
  NotificationsModule,
  RoomModule,
  RootState,
  WorkOrderModule,
} from '../redux';
import { DispatchProp, connect } from 'react-redux';
import { EditItemsModal, EditItemsModalProps, EditValues } from '../modals/edit-items-modal';
import ProjectOverviewTable, {
  ProjectOverviewTableProps,
  SortTable,
} from '../components/project_overview/project_overview_table';
import React, {
  ChangeEvent,
  UIEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import BasicDetail from '../components/UI/basic_detail';
import { CSSTransition } from 'react-transition-group';
import ClientModal from '../containers/client/client_modal';
import ClientMoreDetails from '../components/clients/client_more_details';
import LoadingModal from '../modals/loading-modal';
import { SearchSelectProps } from '../components/UI/search_select/search_select';
import { SortTableRowInfo } from '../components/UI/table/sort_table';
import styled from '../theme';
import { Config } from '../utils';
import { ConfirmationModal } from '../../src/modals/confirmation_modal';
// import Divider from '../components/UI/divider/Divider';
import { getRooms } from '../api/room';
import { getAllRolesByAccountId } from '../api/roles';
import { addNewAssignee, editAssignee, getAllAssigneesByAccountId } from '../api/assignees';
import { getUser, inviteMember } from '../api/users';
// import ClientTabs from "../components/clients/client_tabs";
import {
  archiveClientProjectItem,
  deleteClientProject,
  draperyOrderCopy,
  editClientProject,
  getClientApi,
  getClientProjects,
  searchClients,
} from '../api/client';
import { editWorkOrder, getWorkOrderPDFContent } from '../api/work-order';
import { FadeLoader } from 'react-spinners';
import { getAllInfo, getTotalNumberCount } from '../api/drapery-order';
import { callLambda, getPdfFileNameFromLambdaResponse } from '../api/lambda';
import {
  getMergedPdfPrintUrl,
  isStoredFileMissingError,
  isMergePdfNoneFoundError,
  mergePdfFiles,
  openStoredPdf,
  storeFile,
} from '../api/file-store';
import { WarningModal } from '../modals/warning_modal';
import moment from 'moment';
import { userCanCreateNewOrder } from '../api/drapery-order';
import {
  buyAdditionalSeats,
  changeSubscriptionPlan,
  getAccount,
  getSeatInfo,
  retrieveMetadata,
  updateAccount,
} from '../api/account';
import { readCachedPricingPermission } from '../helper/pricingPermission';
import { trackView } from '../components/analytics/track_view';
import { MixpanelEvents } from '../components/analytics/mix_panel_events';
// import BackButton from '../components/UI/buttons/back-button';
import { RouteComponentProps } from 'react-router-dom';
import { exportEstimate, exportFeeEstimate, quickbooksCheckIsConnected } from '../api/quickbooks';
import {
  CustomColumnPreference,
  getColumnVisibilityPreference,
  saveCustomColumnsPreference,
  upsertColumnVisibilityPreference,
} from '../api/column-visibility-preferences';
import EstimateModal from '../modals/estimate_modal';
import ExportConfirmationModal from '../modals/export-confirmation-modal';
import { editDraperyOrderSummaryComponent } from '../api/drapery-order-summary-component';
import { regenerateWorkOrderDrawing } from '../helper/regenerate-work-order-drawing';
import { initial_project_statuses, initial_statuses } from '../initials/initials';
import {
  addNewProjectStatus,
  addNewStatus,
  getAllStatuses,
  getProjectStatuses,
} from '../api/statuses';
import Filter from '../components/filter/Filter';
import FiltersDrawer from '../components/filters_drawer/FiltersDrawer';
import ColumnVisibilityMenu from '../components/project_overview/column_visibility_menu';
import {
  DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
  PROJECT_OVERVIEW_COLUMNS,
  ProjectOverviewColumnKey,
  ProjectOverviewColumnVisibility,
  resolveColumnVisibility,
} from '../components/project_overview/column_visibility';
import FeesTable from '../components/tables/FeesTable';
import {
  normalizeCustomColumnsConfig,
  writeCustomColumnValue,
  type CustomColumnId,
} from '../components/orderingAndReceiving/custom_columns';
import PlusIcon from '../assets/icons/add.svg';
import UserCheckIcon from '../assets/icons/user-check.svg';
import { getAllFees, getAllFeeTypes } from '../api/fees';
import { numberFormatter } from '../helper/numberFormatter';
import {
  isQuickBooksBundleSetupRequired,
  getQuickBooksOnlineErrorTitle,
  getQuickBooksOnlineNotificationSource,
} from '../helper/quickBooksNotifications';
import FeesModal from '../modals/fees_modal';
import { hasSemicolonInName } from '../helper/handleCheckClient';
import QuickBooksErrorModal from '../modals/quickBooksErrorModal';
import BundleSetupModal from '../modals/bundle_setup_modal';
import { PopoverScrollContext } from '../ui_components/popover/popover';
import { ClientProject } from '../interfaces/client';
import { checkGate } from '../statsig';
import {
  openQuipaAssistant,
  QUIPA_ASSISTANT_CREATE_PROJECT_GATE,
  QUIPA_ASSISTANT_CLOSED_EVENT,
} from '../components/projects/quipa-assistant-events';
import { duplicatePurchasedGood } from '../api/purchased-goods';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import {
  AtSign,
  CircleCheck,
  CirclePlus,
  ClipboardList,
  CreditCard,
  LucideCheck,
  LucideChevronDown,
  LucidePlus,
  LucideX,
  Mail,
  Search,
  TriangleAlert,
  UserRound,
} from 'lucide-react';
import {
  COLUMN_VISIBILITY_PAGES,
  normalizeAssignmentColumnVisibility,
  normalizeColumnVisibilityPreference,
} from '../helper/columnVisibilityPreference';
import {
  buildRoleAssignmentFilterOptions,
  buildRoleAssignmentOptionsByRoleId,
  extractAssigneesForRoleAssignments,
  extractTeamMembersForRoleAssignments,
  getAssignmentOwnerKeys,
  getRoleColumnsForTarget,
  resolveRoleAssignmentOwnerAccountId,
  type RoleAssignmentOptionsByRoleId,
  type RoleAssignmentRole,
} from '../helper/roleAssignments';
import {
  AssigneeWithoutLoginRow,
  collectUsedLabels,
  extractApiErrorMessage,
  extractSeatLimitFromPlanInfo,
  formatTimeAgo,
  generateUniqueAssigneeLabel,
  InvitePanelMode,
  mapAssigneePayloadToRow,
  normalizeAssigneeLabelInput,
  normalizeRoleIds,
  PendingInvitationRow,
  PermissionTooltipKey,
  PRICING_TABLE_PLANS_GATE,
  readOwnerAccountIdFromStorage,
  resolveOwnerAccountIdFromTeamContext,
  RolePermissionRow,
  showErrorToast,
  showSuccessToast,
  showToast,
  TablePermissionTooltipPosition,
  TeamMemberPermissionDraft,
  TeamMemberRow,
} from './team_settings';
import { getCustomerPlanInfo } from '../api/stripe';
import WideSheet from '../components/wide_sheet/WideSheet';
import { Checkbox } from '../components/ui/checkbox-shadcn';
import { ScrollToPosition } from '../containers/application';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';
import { RadioGroup, RadioGroupItem } from '../components/ui/radio-group';
import { Label } from '../components/ui/label';
import PermissionHelpTooltip from '../components/permission_help_tooltip';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { statusColor } from '../helper/colors';
import { Calendar } from '../components/UI/calendar';
import { updateProject } from '../api/projects';
import Notebook from '../components/notebook/Notebook';
import { Tooltip, TooltipContent, TooltipTrigger } from '../components/ui/tooltip-shadcn';
import ClientOrderingAndReceiving from './ClientOrderingAndReceiving';
import ClientEstimating, { ClientEstimatingRef } from './ClientEstimating';
import EstimateBuilderSheet from '../components/estimating/EstimateBuilderSheet';
import { getAllEstimates } from '../api/estimates';
import type { ProjectEstimate } from '../interfaces/project-estimate';
import { extractParent } from '../helper/helpers';
import { logClientPhase, startStopwatch } from '../api/perf-telemetry';
import {
  getClientCacheClient,
  getClientCacheRooms,
  setClientCacheClient,
  setClientCacheRooms,
} from '../api/client-cache';
import { getProjectListCache, setProjectListCache } from '../api/project-list-cache';
import POs, { POsRefType } from '../components/pos/POs';
import { getSuppliers } from '../api/supplier';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/UI/dropdown-menu';

const resolveClientBillingDetails = (client: any) => {
  if (!client) return null;
  if (client.billToParent) {
    return client.billingDetails || client.billingInfo || null;
  }
  return client.billingDetailsDirectly || client.billingInfoDirectly || null;
};

const normalizePriceAdjustment = (type: any, value: any) => {
  const hasAdjustment = type === 'markup' || type === 'discount';
  if (!hasAdjustment) {
    return {
      adjustmentType: 'none',
      adjustmentValue: 0,
      signedValue: 0,
      multiplier: 1,
      hasAdjustment: false,
    };
  }

  const parsedValue = Number(value);
  const adjustmentValue = Number.isFinite(parsedValue) ? parsedValue : 0;
  const signedValue = type === 'discount' ? -adjustmentValue : adjustmentValue;

  return {
    adjustmentType: type,
    adjustmentValue,
    signedValue,
    multiplier: 1 + signedValue / 100,
    hasAdjustment: true,
  };
};

const getClientPriceAdjustment = (client: any) => {
  const billingDetails = resolveClientBillingDetails(client);
  const adjustmentType = billingDetails?.additionalPriceAdjustment || 'none';
  const adjustmentValue = billingDetails?.additionalPriceAdjustmentValue;
  return normalizePriceAdjustment(adjustmentType, adjustmentValue);
};

const getFeeBaseTotal = (quantity: any, unitPrice: any) => {
  const qty = Number(quantity) || 0;
  const price = Number(unitPrice) || 0;
  return qty * price;
};

const getFeeSnapshotAdjustment = (fee: any) =>
  normalizePriceAdjustment(fee?.clientPriceAdjustmentType, fee?.clientPriceAdjustmentValue);

const isFeeLockedOrExported = (fee: any) =>
  !!fee?.clientPriceAdjustmentLockedAt || fee?.estimateStatus === 'Exported to QB';

const getFeeAdjustmentForDisplay = (fee: any, liveAdjustment: any) => {
  const snapshotAdjustment = getFeeSnapshotAdjustment(fee);
  if (isFeeLockedOrExported(fee)) {
    return snapshotAdjustment;
  }
  if (snapshotAdjustment.hasAdjustment) {
    return snapshotAdjustment;
  }
  return liveAdjustment;
};

const getFeeAdjustmentForInlineEdit = (fee: any, liveAdjustment: any) => {
  if (isFeeLockedOrExported(fee)) {
    return getFeeSnapshotAdjustment(fee);
  }
  return liveAdjustment;
};

const getClientSnapshotForFee = (liveAdjustment: any) => ({
  type: liveAdjustment.hasAdjustment ? liveAdjustment.adjustmentType : null,
  value: liveAdjustment.hasAdjustment ? liveAdjustment.adjustmentValue : null,
});

const hasFeeClientPriceAdjustmentSnapshot = (fee: any) =>
  !!fee?.clientPriceAdjustmentType || !!fee?.clientPriceAdjustmentLockedAt;

const shouldShowClientPriceAdjustmentColumn = (fees: any[], liveAdjustment: any) =>
  liveAdjustment.hasAdjustment || fees.some(hasFeeClientPriceAdjustmentSnapshot);

const getFeeDisplayTotal = ({
  fee,
  quantity,
  unitPrice,
  adjustmentMultiplier,
  applyAdjustment,
  preferStoredTotal,
}: {
  fee: any;
  quantity?: any;
  unitPrice?: any;
  adjustmentMultiplier: number;
  applyAdjustment: boolean;
  preferStoredTotal: boolean;
}) => {
  const baseTotal = getFeeBaseTotal(quantity ?? fee?.quantity, unitPrice ?? fee?.unitPrice);
  if (preferStoredTotal && fee?.estimateStatus === 'Exported to QB') {
    const storedTotal = Number(fee?.totalPrice);
    if (Number.isFinite(storedTotal)) {
      return storedTotal;
    }
  }
  const multiplier = applyAdjustment ? adjustmentMultiplier : 1;
  return baseTotal * multiplier;
};

const applyClientAdjustmentToFees = (fees: any[], liveAdjustment: any) =>
  fees.map((fee) => {
    const feeAdjustment = getFeeAdjustmentForDisplay(fee, liveAdjustment);
    const computedTotal = getFeeDisplayTotal({
      fee,
      adjustmentMultiplier: feeAdjustment.multiplier,
      applyAdjustment: feeAdjustment.hasAdjustment,
      preferStoredTotal: true,
    });
    return {
      ...fee,
      totalPrice: numberFormatter(computedTotal),
    };
  });

const CSSTransitionBox = styled.div`
  .content-enter {
    opacity: 0;
    transform: scale(0.9);
  }

  .content-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 300ms,
      transform 300ms;
  }

  .content-exit {
    opacity: 1;
  }

  .content-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition:
      opacity 300ms,
      transform 300ms;
  }
`;

const ClientInfo = styled.div`
  // height: calc(100vh - 165px);
  overflow: visible;
  width: 100%;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
`;

const DuplicateSpinner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000000;
`;

const ALL_ITEMS_OPTION = 'All Items';
const PURCHASED_GOODS_FILTER_OPTION = 'Purchased Goods';

const isAllItemsOption = (value: string) => value.trim().toLowerCase() === 'all items';

const buildItemTypeFilterOptions = (items: string[] = [], hasPurchasedGoods: boolean = false) => {
  let romanShade: string | null = null;
  let drapery: string | null = null;
  let purchasedGoods: string | null = null;
  const remaining: string[] = [];

  items.forEach((item) => {
    if (typeof item !== 'string') return;
    const trimmed = item.trim();
    if (!trimmed) return;
    if (isAllItemsOption(trimmed)) return;
    const normalized = trimmed.toLowerCase();
    if (normalized === 'roman shade') {
      if (!romanShade) {
        romanShade = trimmed;
      } else {
        remaining.push(trimmed);
      }
      return;
    }
    if (normalized === 'drapery') {
      if (!drapery) {
        drapery = trimmed;
      } else {
        remaining.push(trimmed);
      }
      return;
    }
    if (
      normalized === 'purchased goods' ||
      normalized === 'purchased-goods' ||
      normalized === 'purchased good'
    ) {
      if (!purchasedGoods) {
        purchasedGoods = PURCHASED_GOODS_FILTER_OPTION;
      } else {
        remaining.push(trimmed);
      }
      return;
    }
    remaining.push(trimmed);
  });

  const ordered = [ALL_ITEMS_OPTION];
  if (romanShade) ordered.push(romanShade);
  if (drapery) ordered.push(drapery);
  if (purchasedGoods || hasPurchasedGoods) {
    ordered.push(purchasedGoods || PURCHASED_GOODS_FILTER_OPTION);
  }
  ordered.push(...remaining);

  const unique: string[] = [];
  const seen = new Set<string>();
  ordered.forEach((item) => {
    const key = item.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(item);
  });

  return unique;
};

const defaultEditItemModalTargetValues = () => {
  return {
    roomName: '',
    status: '',
    invoicePaid: '',
    productionStartDate: '',
    productionFinishedDate: '',
    installDate: '',
  };
};

const SINGLE_PROJECT_COLUMN_KEYS = PROJECT_OVERVIEW_COLUMNS.map((column) => column.key);

export interface ClientOwnProps extends RouteComponentProps {
  /**
   * Client id to display
   */
  clientId: number;
  onClose(): void;
  onOtherClientChoosed(id: number): void;
  onClientChanged(client: ClientModule.Client): void;
  gotoDraperyOrder(
    clientId?: number | undefined,
    draperyOrderId?: number,
    clientDisplayName?: string,
    tab?: 'summary' | 'setup',
    customOrderType?: string | null
  ): void;
  list: SortTableRowInfo[];
  isConnected?: boolean;
  handleOpenSubscriptionPlanModal(): void;
  handleShowBottomSheet(val: boolean, client?: any): void;
  handlePreFill?(payload: any): void;
  handleOpenSinglePurchasedGoods?(val: number | null): void;
  purchasedGoodsRefetch?: boolean;
  accountUser?: any;
  canAccessTeamSettings?: boolean;
  handleUpdateTeamMembers?(items: any[]): void;
  backToTop?: boolean;
  pageScrollTo?(position: ScrollToPosition, val: number): void;
}

export interface EditItemModalTargetValues {
  roomName: string;
  roomId?: number;
  status: string;
  invoicePaid: string;
  productionStartDate: string;
  productionFinishedDate: string;
  installDate: string;
}

interface ClientProps extends ClientOwnProps {
  accountId: number;
}

export type FeeItem = {
  id: number;
  accountId: number;
  clientId: number;
  status: string | null;
  item: any;
  feeDescription: string | null;
  estimateStatus: string | null;
  estimateDate: Date | null | string;
  estimateNumber: string | null;
  invoiceStatus: string | null;
  invoiceDate: Date | null | string;
  quantity: number | null;
  unitPrice: string | null;
  totalPrice: string | null;
  createdAt: Date;
  updatedAt: Date;
};

interface State {
  isEditClientModalOpen: boolean;
  detailsDisplayed: boolean;
  isNoteEditMode: boolean;
  client?: ClientModule.Client;
  accountId: number;
  clientId: number;
  displayContent: boolean;
  projectList: ClientDashboardModule.ClientProject[];
  roomList: RoomModule.Room[];
  workOrderPdfStatus: 'none' | 'downloading' | 'error';
  workOrderPdfContent?: WorkOrderModule.WorkOrderPdfContent;
  modalKey: number;
  isEditItemsModalOpen: boolean;
  isLoadingOpen: boolean;
  editItemModalTargetValues: EditItemModalTargetValues;
  checkedProjects: number[];
  areaScrollInfo: {
    scrollX: number;
    scrollY: number;
  };
  showArchived: boolean;
  isModalOpen: boolean;
  value: string;
  sortValue: { field: string; direction: 'ASC' | 'DESC' };
  addSubClient: boolean;
  initialClientState?: boolean;
  parentClients: any[];
  duplicateLoading: boolean;
  exportingEstimateLoading: boolean;
  isEstimateModalOpen: boolean;
  qbEstimateId?: string | null;
  qbEstimateDocNumber?: string | null;
  filters: any;
  filtersDraft: any;
  columnVisibility: ProjectOverviewColumnVisibility;
  isMobile: boolean;
  items: string[];
  rooms: any[];
  modalMessage: string;
  ordersWithoutWO: number[];

  isExportConfirmationModalOpen: boolean;
  selectedNumber: number;
  notReadyOrders: number;
  accountStatuses: any;
  refetch: boolean;
  projectRefetch: boolean;
  newStatusFilter: boolean;
  newStatusFilterValue: string;
  table_type: string;
  isSubmenuOpened: boolean;
  feesData: FeeItem[];
  feeTypes: any[];
  refetchFees: boolean;
  loading: boolean;
  selectedFees: any[];
  feesFilter: {
    status: string | null;
  };
  feesModalActive: boolean;
  singleOrder: number[];
  quickBooksErrorModal: boolean;
  isBundleSetupModalOpen: boolean;
  bundleSetupMissingItems: string[];
  bundleSetupPendingIds: number[];
  bundleSetupPendingFees: number[];
  bundleSetupSource?: string;
  remainingItemOrder: number;
  canCreateOrder: boolean;
  accountIsAdmin: boolean;
  accountCanSeePricing: boolean;
  isPrintModalOpen: boolean;
  generatePdf: boolean;
  searchTerm: string;
}

let initialSeatState = {
  interval: 'month',
  quantity: '1',
  cost: '0.00',
};

let initialPills = [
  {
    id: 1,
    label: 'Status',
    type: 'status',
    value: null,
    items: [],
  },
  {
    id: 2,
    label: 'Estimate',
    type: 'estimate',
    value: null,
    readOnly: true,
    items: [
      { id: 1, label: 'Not Created', value: 'Not Created' },
      { id: 2, label: 'Created', value: 'Created' },
      { id: 3, label: 'Exported to QB', value: 'Exported to QB' },
      { id: 4, label: 'Sent to Customer', value: 'Sent to Customer' },
    ],
  },
  {
    id: 3,
    label: 'Invoice',
    type: 'invoice',
    value: null,
    items: [
      { id: 1, label: 'Not Created', value: 'Not Created' },
      { id: 2, label: 'Not Paid', value: 'Not Paid' },
      { id: 3, label: 'Partial', value: 'Partial' },
      { id: 4, label: 'Paid', value: 'Paid' },
    ],
  },
  { id: 4, label: 'Install', type: 'install', value: null, items: [] },
];

export const Client: React.FC<ClientProps & DispatchProp> = (props) => {
  const posRef = useRef<POsRefType>(null);
  const estimateRef = useRef<ClientEstimatingRef>(null);
  const newStatusRef = useRef<any>(null);
  const submenuRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const setFocusFirstFieldOnClientModalRef = useRef<any>(null);

  const query = useMemo(() => {
    const query_obj: { openDetails: boolean } = {
      openDetails: false,
    };

    const openDetails = sessionStorage.getItem('openDetails');
    if (openDetails) {
      query_obj.openDetails = JSON.parse(openDetails) || false;
    }
    sessionStorage.removeItem('openDetails');
    return query_obj;
  }, []);

  const [state, _setState] = useState<State>(() => ({
    modalKey: 0,
    isEditClientModalOpen: false,
    detailsDisplayed: query.openDetails || false,
    isNoteEditMode: false,
    clientId: 0,
    accountId: 0,
    displayContent: false,
    roomList: [
      {
        id: 0,
        name: '',
        description: '',
      },
    ],
    workOrderPdfStatus: 'none',
    projectList: [],

    isEditItemsModalOpen: false,
    isLoadingOpen: false,
    editItemModalTargetValues: defaultEditItemModalTargetValues(),
    checkedProjects: [],
    areaScrollInfo: {
      scrollX: 0,
      scrollY: 0,
    },
    showArchived: false,
    isModalOpen: false,
    modalMessage: '',
    ordersWithoutWO: [],
    value: '',
    addSubClient: false,
    parentClients: [],
    sortValue: { field: '', direction: 'ASC' },
    duplicateLoading: false,
    exportingEstimateLoading: false,
    isEstimateModalOpen: false,
    qbEstimateId: '',
    qbEstimateDocNumber: '',
    filters: {
      rooms: { value: [] },
      items: { value: [] },
      status: { value: [] },
      estimate: { value: [] },
      invoice: { value: [] },
      assignee: { value: [] },
    },
    filtersDraft: {
      rooms: { value: [] },
      items: { value: [] },
      status: { value: [] },
      estimate: { value: [] },
      invoice: { value: [] },
      assignee: { value: [] },
    },
    columnVisibility: DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
    isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
    items: [],
    rooms: [],

    isExportConfirmationModalOpen: false,
    selectedNumber: 0,
    notReadyOrders: 0,
    accountStatuses: initial_statuses,
    refetch: false,
    projectRefetch: false,
    newStatusFilter: false,
    newStatusFilterValue: '',
    table_type: 'items',
    isSubmenuOpened: false,
    feesData: [],
    feeTypes: [],
    refetchFees: false,
    loading: true,
    selectedFees: [],
    feesFilter: {
      status: '',
    },
    feesModalActive: false,
    singleOrder: [],
    quickBooksErrorModal: false,
    isBundleSetupModalOpen: false,
    bundleSetupMissingItems: [],
    bundleSetupPendingIds: [],
    bundleSetupPendingFees: [],
    bundleSetupSource: undefined,
    remainingItemOrder: 0,
    canCreateOrder: true,
    accountIsAdmin: false,
    accountCanSeePricing: readCachedPricingPermission(false),
    isPrintModalOpen: false,
    generatePdf: false,
    searchTerm: '',
  }));
  const [roleAssignmentColumns, setRoleAssignmentColumns] = useState<RoleAssignmentRole[]>([]);
  const [roleColumnVisibility, setRoleColumnVisibility] = useState<Record<number, boolean>>({});
  const [customColumnsConfig, setCustomColumnsConfig] = useState<CustomColumnPreference[]>([]);
  const normalizedCustomColumns = useMemo(
    () => normalizeCustomColumnsConfig(customColumnsConfig),
    [customColumnsConfig]
  );
  const [account, setAccount] = useState<any>(null);
  const [refetchRoles, setRefetchRoles] = useState<boolean>(false);
  const [unsetRoleColumns, setUnsetRoleColumns] = useState<RoleAssignmentRole[]>([]);
  const [estimateSheetState, setEstimateSheetState] = useState<{
    open: boolean;
    estimateId: number | null;
    estimates: ProjectEstimate[];
  }>({
    open: false,
    estimateId: null,
    estimates: [],
  });

  const prevPropsRef = useRef<any>(props);
  const prevStateRef = useRef<State>(state);
  const isSubmenuOpenedRef = useRef<boolean>(state.isSubmenuOpened);
  // ADD TEAM MEMBER WIDE SHEET
  const firstName = (localStorage.getItem('firstName') || '').trim();
  const lastName = (localStorage.getItem('lastName') || '').trim();
  // @ts-ignore
  const [accountIsOwner, setAccountIsOwner] = useState(false);
  const canManageTeamMembers = accountIsOwner || account?.isAdmin;
  const canUseRoleAssignments = !!props.canAccessTeamSettings;
  const canCustomizeCustomColumns = !!accountIsOwner || !!account?.isOwner || !!account?.isAdmin;
  const visibleCustomColumns = normalizedCustomColumns;
  const [isInvitePanelOpen, setIsInvitePanelOpen] = useState(false);
  const [openPermissionTooltip, setOpenPermissionTooltip] = useState<PermissionTooltipKey | null>(
    null
  );
  const [invitePanelMode, setInvitePanelMode] = useState<InvitePanelMode>('team_member');
  const [usedSlots, setUsedSlots] = useState(0);
  const [availableSlots, setAvailableSlots] = useState(0);
  const normalizedAvailableSlots = Math.max(availableSlots, 0);
  const isSeatLimitReached = usedSlots >= normalizedAvailableSlots;
  const [isInvitingMember, setIsInvitingMember] = useState(false);
  const [memberEmail, setMemberEmail] = useState('');
  const [memberSelectedRoleIds, setMemberSelectedRoleIds] = useState<number[]>([]);
  const [memberPricingAccess, setMemberPricingAccess] = useState(false);
  const [memberAdminAccess, setMemberAdminAccess] = useState(false);
  const [assigneeName, setAssigneeName] = useState('');
  const [teamScopeAccountId, setTeamScopeAccountId] = useState(
    prevPropsRef?.current?.accountUser?.teamContext?.owner?.accountId ||
      prevPropsRef?.current?.accountId
  );
  const [assigneeLabel, setAssigneeLabel] = useState('');
  const [assigneeSelectedRoleIds, setAssigneeSelectedRoleIds] = useState<number[]>([]);
  const [teamMembers, setTeamMembers] = useState<any[]>(
    props.accountUser?.teamContext?.teamMembers || []
  );
  useEffect(() => {
    setTeamMembers(props.accountUser?.teamContext?.teamMembers || []);
  }, [props.accountUser?.teamContext?.teamMembers]);
  const ownerTeamMemberAccountId = teamMembers.find((member) => member.isOwner)?.accountId || 0;
  const ownerAccountIdFromStorage = readOwnerAccountIdFromStorage();
  const managedAccountId = teamScopeAccountId || prevPropsRef?.current?.accountId;
  const assigneeScopeAccountId =
    ownerTeamMemberAccountId || ownerAccountIdFromStorage || managedAccountId;
  const [assigneeMutationState, setAssigneeMutationState] = useState<
    null | 'adding' | 'editing' | 'deleting'
  >(null);
  const [assigneesWithoutLogin, setAssigneesWithoutLogin] = useState<AssigneeWithoutLoginRow[]>([]);
  // @ts-ignore
  const [teamMemberPermissionBaseline, setTeamMemberPermissionBaseline] = useState<
    Record<string, TeamMemberPermissionDraft>
  >({});
  // @ts-ignore
  const [pendingTeamMemberPermissions, setPendingTeamMemberPermissions] = useState<
    Record<string, TeamMemberPermissionDraft>
  >({});
  // @ts-ignore
  const [ownerEmail, setOwnerEmail] = useState('');
  // @ts-ignore
  const [pendingSlots, setPendingSlots] = useState(0);
  const [pendingInvitations, setPendingInvitations] = useState<PendingInvitationRow[]>([]);
  // @ts-ignore
  const [planName, setPlanName] = useState('');
  const assignmentOptionsByRoleId = useMemo<RoleAssignmentOptionsByRoleId>(() => {
    if (!canUseRoleAssignments) {
      return {};
    }

    return buildRoleAssignmentOptionsByRoleId(
      roleAssignmentColumns,
      extractTeamMembersForRoleAssignments({ teamMembers }),
      extractAssigneesForRoleAssignments(assigneesWithoutLogin)
    );
  }, [assigneesWithoutLogin, canUseRoleAssignments, roleAssignmentColumns, teamMembers]);
  const isAssigneeMutationLoading = assigneeMutationState !== null;
  const canSubmitInvitePanel =
    invitePanelMode === 'team_member'
      ? memberEmail.trim().length > 0 && !isSeatLimitReached && !isInvitingMember
      : assigneeName.trim().length > 0 &&
        assigneeLabel.trim().length > 0 &&
        assigneeSelectedRoleIds.length > 0 &&
        !isAssigneeMutationLoading;
  const [isAssigneeLabelAuto, setIsAssigneeLabelAuto] = useState(true);
  const [roles, setRoles] = useState<RolePermissionRow[]>([]);
  const [isRemovingInactiveMembers, setIsRemovingInactiveMembers] = useState(false);
  // @ts-ignore
  const [resendingInvitationId, setResendingInvitationId] = useState<string | null>(null);
  // @ts-ignore
  const [deletingInvitationId, setDeletingInvitationId] = useState<string | null>(null);
  const seatUsagePercent = normalizedAvailableSlots
    ? Math.min((Math.max(usedSlots, 0) / normalizedAvailableSlots) * 100, 100)
    : 0;
  const remainingSeatsAfterInvite = Math.max(normalizedAvailableSlots - (usedSlots + 1), 0);
  // @ts-ignore
  const [openTablePermissionTooltip, setOpenTablePermissionTooltip] =
    useState<PermissionTooltipKey | null>(null);
  // @ts-ignore
  const [tablePermissionTooltipPosition, setTablePermissionTooltipPosition] =
    useState<TablePermissionTooltipPosition | null>(null);
  const [openSeatsModal, setOpenSeatsModal] = useState(false);
  const [seatState, setSeatState] = useState(initialSeatState);
  const [availableSeats, setAvailableSeats] = useState<any>(null);
  const [seatLoading, setSeatLoading] = useState<boolean>(false);
  // END OF ADD TEAM MEMBER WIDE SHEET
  const [rolePills, setRolePills] = useState<any[]>([]);
  const [pills, setPills] = useState<any[]>(initialPills);
  const [newStatus, setNewStatus] = useState<boolean>(false);
  const [newStatusValue, setNewStatusValue] = useState<string>('');
  const [refetchProjectStatuses, setRefetchProjectStatuses] = useState<boolean>(false);
  const clientProject = (state.client as any)?.project;
  const clientProjectNotebook = (state.client as any)?.projectNotebook || [];

  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [openLinkedPO, setOpenLinkedPO] = useState<string>('');

  const handleRefetchProjectStatuses = () => {
    setRefetchProjectStatuses((prev) => !prev);
  };

  const handleSetNewStatus = () => {
    setNewStatus((prev) => !prev);
  };

  const handleChangeNewStatus = (e: ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;
    setNewStatusValue(value);
  };

  const handleSavePillNewStatus = async () => {
    const payload: { accountId?: number; name: string } = {
      name: newStatusValue,
    };
    if (managedAccountId) {
      payload['accountId'] = managedAccountId;
    }
    const res = await addNewProjectStatus(payload);
    if (res) {
      setNewStatusValue('');
      setNewStatus(false);
      handleRefetchProjectStatuses();
    }
  };

  useEffect(() => {
    isSubmenuOpenedRef.current = state.isSubmenuOpened;
  }, [state.isSubmenuOpened]);

  const setState = useCallback(
    (updater: Partial<State> | ((prev: State) => Partial<State>), callback?: () => void) => {
      _setState((prev) => {
        const patch = typeof updater === 'function' ? updater(prev) : updater;
        return { ...prev, ...patch };
      });
      if (callback) {
        setTimeout(callback, 0);
      }
    },
    []
  );

  const loadColumnVisibilityPreference = useCallback(async () => {
    if (!props.accountId) {
      return;
    }

    try {
      const preference = await getColumnVisibilityPreference({
        accountId: props.accountId,
        page: COLUMN_VISIBILITY_PAGES.singleProject,
      });
      setState({
        columnVisibility: resolveColumnVisibility(
          normalizeColumnVisibilityPreference(
            SINGLE_PROJECT_COLUMN_KEYS,
            preference?.visibility?.columns
          )
        ),
      });
      setRoleColumnVisibility(
        normalizeAssignmentColumnVisibility(preference?.visibility?.assignmentColumns)
      );
      setCustomColumnsConfig(
        Array.isArray(preference?.visibility?.customColumns)
          ? preference.visibility.customColumns
          : []
      );
    } catch (error) {
      console.error('Failed to load column visibility preferences for single-project page:', error);
    }
  }, [props.accountId, setState]);

  useEffect(() => {
    void loadColumnVisibilityPreference();
  }, [loadColumnVisibilityPreference]);

  const handleResetCheckedFees = () => {
    setState((prev) => {
      return {
        ...prev,
        selectedFees: [],
      };
    });
  };

  const handleFeeEstimate = async (ids: []) => {
    if (hasSemicolonInName(state.client)) {
      handleOpenQuickBooksErrorModal(true);
      return;
    }

    setState({ exportingEstimateLoading: true });
    const res = await quickbooksCheckIsConnected(props.accountId);
    const { dispatch } = props;

    if (res.connected === true && res.userinfo) {
      const res = await exportFeeEstimate(ids, props.accountId);

      if (!ids.length) return;
      if (!res.error) {
        if (ids.length === 1) {
          // const project = [...state.projectList].find((p) => p.itemId === ids[0]);
          // if (project) {
          //   console.log('empty');
          //   const newValues = {
          //     ...project,
          //     estimateDateSent: new Date(),
          //     estimateNumber: 'Exported to QB',
          //   };
          //   await editProjectItem(newValues);
          // }
        } else {
          // const projects = [...state.projectList].filter((p) => ids.includes(p.itemId));
          // console.log('empty');
          // const promises = projects.map(async (p) => {
          //   const newValues = {
          //     ...p,
          //     estimateDateSent: new Date(),
          //     estimateNumber: 'Exported to QB',
          //   };
          //   return await editProjectItem(newValues);
          // });
          // //   const draperyPromises = projects.map(async (p) => {
          // //     return await editDraperyOrder({ id: p.itemId, qboLink: res.qboLink });
          // //   });
          // await Promise.all([
          //   ...promises,
          //   //  ...draperyPromises
          // ]);
        }
        loadProjects();
        setState({
          isEstimateModalOpen: true,
          checkedProjects: [],
          qbEstimateId: res.estimateId,
          qbEstimateDocNumber:
            res && res.result && res.result.Estimate && res.result.Estimate.DocNumber
              ? res.result.Estimate.DocNumber
              : undefined,
          exportingEstimateLoading: false,
        });

        handleGetAllFees();
      }
      if (res.error) {
        setState({ exportingEstimateLoading: false });
        const notification: NotificationsModule.AddNotificationPayload = {
          message: getQuickBooksOnlineErrorTitle(res) || 'Error!',
          subMessage: `${res.message}`,
          type: 'error',
          source: getQuickBooksOnlineNotificationSource(res),
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
    } else {
      props.history.push('/quickbooks_connect');
    }
  };

  const handleCheckAllFeeRows = () => {
    const row_ids =
      state.selectedFees && state.selectedFees.length > 0
        ? []
        : state.feesData && state.feesData.length > 0
          ? state.feesData.map((t: any) => t.id)
          : [];
    setState((prev) => {
      return {
        ...prev,
        selectedFees: row_ids,
      };
    });
  };

  const handleSelectFeeRows = (row: any) => {
    setState((prev: any) => {
      return {
        ...prev,
        selectedFees: prev.selectedFees.includes(row)
          ? prev.selectedFees.filter((f: any) => f !== row)
          : [...prev.selectedFees, row],
      };
    });
  };

  const handleGetAllStatuses = async () => {
    // const { accountId } = props;

    if (!managedAccountId) {
      console.error('Account ID is missing.');
      return;
    }

    const payload = {
      accountId: managedAccountId,
    };

    const res = await getAllStatuses(payload);
    if (res && !res.error) {
      const mapped_res =
        res && res.length > 0
          ? res.map((s: any) => {
              return {
                ...s,
                value: s.name,
              };
            })
          : [];
      setState((prev) => {
        return {
          ...prev,
          accountStatuses: [...mapped_res, ...initial_statuses],
        };
      });
    }
  };

  const handleFetchProjectStatuses = async () => {
    if (!managedAccountId) {
      console.error('Account ID is missing!');
      return;
    }
    const payload = {
      accountId: managedAccountId,
    };
    const response = await getProjectStatuses(payload);
    if (response && !response.error) {
      const mapped_res =
        response && response.length > 0
          ? response.map((i: any) => {
              return {
                ...i,
                value: i.name,
                label: i.name,
              };
            })
          : [];
      // Initial status built for pill mapping
      let initial_statuses_with_id = initial_project_statuses?.map((i: any, idx: number) => ({
        id: `initial_status_${idx + 1}`,
        ...i,
        label: i?.name,
      }));
      setPills((prev) => {
        return prev.map((i: any) => {
          if (i?.type === 'status') {
            return {
              ...i,
              items: [...mapped_res, ...initial_statuses_with_id],
            };
          }
          return i;
        });
      });
    }
  };

  useEffect(() => {
    handleFetchProjectStatuses();
  }, [refetchProjectStatuses]);

  const loadRoleAssignmentConfig = useCallback(async (): Promise<void> => {
    if (!canUseRoleAssignments) {
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
      return;
    }

    const accountId = Number(props.accountId);
    if (!accountId) {
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
      return;
    }

    try {
      // const user = await getUser({ accountId, includeTeamData: true });
      const user = props.accountUser;
      const teamContext = user?.teamContext || {};
      const ownerAccountId = resolveRoleAssignmentOwnerAccountId(accountId, teamContext);
      const [rolesResponse, assigneesResponse] = await Promise.all([
        getAllRolesByAccountId({ accountId: ownerAccountId }),
        getAllAssigneesByAccountId({ accountId: ownerAccountId }),
      ]);

      const columns = getRoleColumnsForTarget(rolesResponse, 'items');
      const columnsForProject = getRoleColumnsForTarget(rolesResponse, 'projects');
      const unsetRoleColumns: any[] =
        rolesResponse?.filter((i: any) => i && i.items === false) || [];

      setRoleAssignmentColumns(columns);
      let assigneesMap: any[] = (assigneesResponse || []).map(mapAssigneePayloadToRow);
      setAssigneesWithoutLogin(assigneesMap);
      setUnsetRoleColumns(unsetRoleColumns);

      const handleTeamMembersByRoles = (role: any, members: any[]) => {
        if (!members || members?.length <= 0) return [];

        return members?.filter((m) => m?.roles?.includes(role?.id));
      };

      let teamMembersWithFakeId = (user?.teamContext?.teamMembers || []).map(
        (i: any, idx: number) => {
          return {
            ...i,
            fakeId: `team_member_id_${idx + 1}`,
          };
        }
      );
      let assigneesWithFakeId = (assigneesResponse || []).map((i: any, idx: number) => {
        return {
          ...i,
          fakeId: `assignee_id_${idx + 1}`,
        };
      });
      setRolePills(
        columnsForProject?.length > 0
          ? columnsForProject?.map((i) => {
              return {
                ...i,
                label: i.name,
                // value: null,
                items: handleTeamMembersByRoles(i, [
                  ...teamMembersWithFakeId,
                  ...assigneesWithFakeId,
                ]),
              };
            })
          : []
      );
    } catch (error) {
      console.error('Failed to load role assignments config for client overview:', error);
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
    }
  }, [
    canUseRoleAssignments,
    props.accountId,
    props.accountUser?.teamContext?.owner?.accountId,
    props.accountUser?.teamContext?.ownerAccountId,
    refetchRoles,
  ]);

  const handleTriggerRefetch = () => {
    setState((prev) => {
      return { ...prev, refetch: !prev.refetch };
    });
  };

  const handleTriggerProjectRefetch = () => {
    setState((prev) => {
      return { ...prev, projectRefetch: !prev.projectRefetch };
    });
  };

  const handleTriggerFeesRefetch = () => {
    setState((prev) => {
      return { ...prev, refetchFees: !prev.refetchFees };
    });
  };

  const loadEstimatesForCurrentClient = async (): Promise<ProjectEstimate[]> => {
    const activeClientId = Number(state.client?.id || props.clientId || 0);
    const activeAccountId = Number(props.accountId || 0);
    if (!activeClientId || !activeAccountId) return [];
    const response = await getAllEstimates({
      clientId: activeClientId,
      accountId: activeAccountId,
    });
    return Array.isArray(response) ? (response as ProjectEstimate[]) : [];
  };

  const handleOpenEstimateFromStatus = async (estimateId: number) => {
    if (!state.accountCanSeePricing) return;
    const normalizedEstimateId = Number(estimateId || 0);
    if (!Number.isInteger(normalizedEstimateId) || normalizedEstimateId <= 0) return;
    try {
      const estimates = await loadEstimatesForCurrentClient();
      setEstimateSheetState({
        open: true,
        estimateId: normalizedEstimateId,
        estimates,
      });
    } catch (error) {
      console.error('Failed to load estimate from status link:', error);
      setEstimateSheetState({
        open: true,
        estimateId: normalizedEstimateId,
        estimates: [],
      });
    }
  };

  const handleEstimateSheetChanged = async () => {
    handleTriggerRefetch();
    handleTriggerProjectRefetch();
    handleTriggerFeesRefetch();
    try {
      const estimates = await loadEstimatesForCurrentClient();
      setEstimateSheetState((prev) => ({ ...prev, estimates }));
    } catch (error) {
      console.error('Failed to refresh estimates after estimate change:', error);
    }
  };

  const handleEstimateSheetSaved = () => {
    setState((prev) => ({ ...prev, table_type: 'estimating' }));
  };

  const handleCloseEstimateSheet = () => {
    setEstimateSheetState((prev) => ({ ...prev, open: false, estimateId: null }));
  };

  const handleInlineChange = (e: any, id: any) => {
    const { name, value } = e.target;

    const quantityRegex = /^(?!0\d)\d*(\.\d{0,2})?$/;
    const unitPriceRegex = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    const clientAdjustment = getClientPriceAdjustment(state.client);

    setState((prev: any) => {
      if (name === 'quantity') {
        if (value && !quantityRegex.test(value)) {
          return;
        }

        const numValue = Number(value);

        if (value !== '' && (isNaN(numValue) || numValue < 0 || numValue >= 1000)) {
          return;
        }
        if (value.startsWith('0') && value !== '0' && !value.includes('0.')) {
          return;
        }
      }

      if (name === 'unitPrice') {
        const new_value = value.replace('$', '');
        if (new_value && !unitPriceRegex.test(new_value)) {
          return;
        }
      }

      return {
        ...prev,
        feesData:
          prev.feesData && prev.feesData.length > 0
            ? prev.feesData.map((fe: any) => {
                if (fe.id === id) {
                  const feeAdjustment = getFeeAdjustmentForInlineEdit(fe, clientAdjustment);
                  const shouldSnapshotClientAdjustment = !isFeeLockedOrExported(fe);
                  const clientSnapshot = getClientSnapshotForFee(clientAdjustment);
                  const snapshotFields = shouldSnapshotClientAdjustment
                    ? {
                        clientPriceAdjustmentType: clientSnapshot.type,
                        clientPriceAdjustmentValue: clientSnapshot.value,
                      }
                    : {};
                  if (name === 'quantity') {
                    const computedTotal = getFeeDisplayTotal({
                      fee: fe,
                      quantity: value,
                      unitPrice: fe.unitPrice,
                      adjustmentMultiplier: feeAdjustment.multiplier,
                      applyAdjustment: feeAdjustment.hasAdjustment,
                      preferStoredTotal: false,
                    });
                    return {
                      ...fe,
                      ...snapshotFields,
                      [name]: value,
                      totalPrice: numberFormatter(computedTotal),
                    };
                  } else if (name === 'unitPrice') {
                    const new_value = value.replace('$', '');
                    const computedTotal = getFeeDisplayTotal({
                      fee: fe,
                      quantity: fe.quantity,
                      unitPrice: new_value,
                      adjustmentMultiplier: feeAdjustment.multiplier,
                      applyAdjustment: feeAdjustment.hasAdjustment,
                      preferStoredTotal: false,
                    });
                    return {
                      ...fe,
                      ...snapshotFields,
                      [name]: new_value,
                      totalPrice: numberFormatter(computedTotal),
                    };
                  } else {
                    return {
                      ...fe,
                      ...snapshotFields,
                      [name]: value,
                    };
                  }
                }
                return fe;
              })
            : [],
      };
    });
  };

  const handleInlineDropdownChange = (row_id: any, fee_key: any, fee_value: any) => {
    setState((prev: any) => {
      return {
        ...prev,
        feesData:
          prev.feesData && prev.feesData.length > 0
            ? prev.feesData.map((fe: any) => {
                if (fe.id === row_id) {
                  return {
                    ...fe,
                    [fee_key]: fee_value,
                  };
                }
                return fe;
              })
            : [],
      };
    });
  };

  const handleChangeNewStatusFilter = (e: any) => {
    const { value } = e.target;
    setState((prev) => {
      return {
        ...prev,
        newStatusFilterValue: value,
      };
    });
  };

  const handleSetNewStatusFilter = () => {
    if (!state.newStatusFilterValue) {
      setState((prev) => ({ ...prev, newStatusFilter: !prev.newStatusFilter }));
    }
  };

  const handleSaveNewStatus = async () => {
    if (state.newStatusFilterValue && state.newStatusFilterValue.trim()) {
      // const accountId = localStorage.getItem('accountId');
      const payload: { accountId?: number; name: string } = {
        name: state.newStatusFilterValue,
      };
      if (managedAccountId) {
        const parsedAccountId = JSON.parse(managedAccountId);
        payload['accountId'] = parsedAccountId;
      }
      const res = await addNewStatus(payload);
      if (res && !res.error) {
        setState((prev) => {
          return {
            ...prev,
            newStatusFilterValue: '',
            newStatusFilter: false,
          };
        });

        handleTriggerRefetch();
      } else {
        console.error(res.error, res.message);
      }
    }
  };

  const handleResetNewStatus = () => {
    setState((prev) => {
      return {
        ...prev,
        newStatusFilter: false,
        newStatusFilterValue: '',
      };
    });
  };

  const handleFeesFilter = (filter_name: string, filter_value: string) => {
    setState((prev) => {
      return {
        ...prev,
        selectedFees: [],
        feesFilter: {
          ...prev.feesFilter,
          [filter_name]: filter_value,
        },
      };
    });
    handleTriggerFeesRefetch();
  };

  const handleGetAllFees = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    const payload = {
      accountId: props.accountId,
      clientId: props.clientId,
      feesFilter: {
        status: state.feesFilter.status,
      },
    };
    const res = await getAllFees(payload);
    if (res && !res.error) {
      const clientAdjustment = getClientPriceAdjustment(state.client);
      const filtered_res = res && res.length > 0 ? res.filter((f: any) => f.item) : [];
      setState((prev) => ({
        ...prev,
        feesData: state.feesModalActive
          ? applyClientAdjustmentToFees(filtered_res, clientAdjustment)
          : applyClientAdjustmentToFees(res || [], clientAdjustment),
        loading: false,
      }));
    }
  };

  const handleGetFeeTypes = async () => {
    const payload = {
      accountId: props.accountId,
      clientId: props.clientId,
    };

    const res = await getAllFeeTypes(payload);
    if (res && !res.error) {
      setState((prev) => ({ ...prev, feeTypes: res || [] }));
    }
  };

  const handleRefetchRoles = () => {
    setRefetchRoles((prev) => !prev);
  };

  const handleAssistantClosed = (_event?: Event) => {
    void loadProjects();
  };
  const componentDidMount = async (): Promise<void> => {
    const mountStopwatch = startStopwatch();
    const phaseCtx = { client_id: props.clientId || undefined };
    const measureClient = async <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      try {
        return await op();
      } finally {
        logClientPhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      }
    };
    // For fire-and-forget background tasks, wrap so we still get phase timings.
    const measureClientBackground = <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      return Promise.resolve(op()).finally(() => {
        logClientPhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    const duplicate = localStorage.getItem('duplicate');
    if (duplicate) {
      const { orderType, id } = JSON.parse(duplicate);
      await measureClient('duplicate_cleanup', async () => {
        await deleteClientProject({
          id: Number(id),
          duplicateNotSaved: true,
        } as unknown as ClientProject);
        localStorage.removeItem('duplicate');

        const canCreateOrder = await userCanCreateNewOrder(props.accountId);
        if (!canCreateOrder && state.remainingItemOrder >= 0 && orderType !== 'custom-order') {
          await updateAccount({
            accountId: props.accountId,
            remainingItemOrder: state.remainingItemOrder + 1,
          });
        }
      });
    }
    // These five fire as background tasks (no await). They run concurrently
    // with the awaited getAccount + userCanCreateNewOrder below. Each
    // self-times via measureClientBackground.
    measureClientBackground('rooms', () => handleGetRooms());
    measureClientBackground('projects', () => loadProjects());
    measureClientBackground('all_statuses', () => handleGetAllStatuses());
    measureClientBackground('all_fees', () => handleGetAllFees());
    measureClientBackground('fee_types', () => handleGetFeeTypes());
    const res = await measureClient('account', () => getAccount(props.accountId));
    setAccount(res);

    if (!res.error) {
      setState((prev) => ({
        ...prev,
        remainingItemOrder: res.remainingItemOrder,
        accountIsAdmin: !!res.isAdmin,
        accountCanSeePricing: !!res.canSeePricing,
      }));
    }

    const can_create_order = await measureClient('can_create_order', () =>
      userCanCreateNewOrder(props.accountId)
    );
    setState((prev) => ({ ...prev, canCreateOrder: can_create_order }));
    document.addEventListener('mousedown', handleClickOutside);
    if (typeof window !== 'undefined') {
      window.addEventListener(QUIPA_ASSISTANT_CLOSED_EVENT, handleAssistantClosed);
    }
    logClientPhase({
      phase: 'mount_returned',
      duration_ms: mountStopwatch.end(),
      ...phaseCtx,
    });
  };
  const componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevState.searchTerm !== state.searchTerm && state.checkedProjects.length > 0) {
      setState({ checkedProjects: [] });
    }

    if (
      prevState.sortValue !== state.sortValue ||
      prevProps.purchasedGoodsRefetch !== props.purchasedGoodsRefetch ||
      prevState.projectRefetch !== state.projectRefetch ||
      prevState.showArchived !== state.showArchived
    ) {
      loadProjects();
    }

    if (prevState.filters !== state.filters) {
      loadProjects();
    }
    if (prevState.addSubClient !== state.addSubClient) {
      setState({
        isEditClientModalOpen: state.addSubClient,
      });
    }

    if (prevState.detailsDisplayed !== state.detailsDisplayed) {
      trackView(MixpanelEvents.CLIENT_DETAILS, {});
    }

    if (prevState.refetch !== state.refetch) {
      handleGetAllStatuses();
    }

    if (prevState.refetchFees !== state.refetchFees) {
      handleGetAllFees();
    }

    if (prevState.client !== state.client && state.feesData.length > 0) {
      const clientAdjustment = getClientPriceAdjustment(state.client);
      setState((prev) => ({
        ...prev,
        feesData: applyClientAdjustmentToFees(prev.feesData || [], clientAdjustment),
      }));
    }

    if (prevState.newStatusFilter !== state.newStatusFilter) {
      if (state.newStatusFilter) {
        if (newStatusRef && newStatusRef.current) {
          newStatusRef.current.focus();
        }
      }
    }
  };

  // handleExportToQBO(clientId: number) {
  //   const oAuthUrl = new URL('https://appcenter.intuit.com/app/connect/oauth2/companyselection');
  //   oAuthUrl.searchParams.append('client_id', 'AByykzCA2v0oKujx6hSWHSvNMzcsCz1zxy0soMtwR8asGejctz');
  //   oAuthUrl.searchParams.append('scope', 'com.intuit.quickbooks.accounting');
  //   oAuthUrl.searchParams.append(
  //     'redirect_uri',
  //     `${window.location.origin}/qbo_client_export_oauth_redirect`
  //   );
  //   oAuthUrl.searchParams.append('response_type', 'code');
  //   oAuthUrl.searchParams.append('state', clientId.toString());
  //   oAuthUrl.searchParams.append('locale', 'en-us');
  //   window.open(oAuthUrl.toString());
  // }

  const handleClearAllFilter = (filter_field: any) => {
    switch (filter_field) {
      case 'rooms':
      case 'items':
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee':
        setState((prev) => {
          return {
            ...prev,
            filters: {
              ...prev.filters,
              [filter_field]: {
                ...prev.filters[filter_field],
                value: [],
              },
            },
            filtersDraft: {
              ...prev.filtersDraft,
              [filter_field]: {
                ...prev.filtersDraft[filter_field],
                value: [],
              },
            },
          };
        });
        break;
      default:
        return;
    }
  };

  const handleChooseFilter = (filter: string, filter_field: any) => {
    switch (filter_field) {
      case 'rooms':
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee':
        let set_array = state.filters[filter_field].value || [];

        if (
          state.filters[filter_field] &&
          state.filters[filter_field].value &&
          state.filters[filter_field].value.includes(filter)
        ) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        setState((prev) => {
          return {
            ...prev,
            filters: {
              ...prev.filters,
              [filter_field]: {
                ...prev.filters[filter_field],
                value: set_array,
              },
            },
            filtersDraft: {
              ...prev.filtersDraft,
              [filter_field]: {
                ...prev.filtersDraft[filter_field],
                value: set_array,
              },
            },
          };
        });
        break;
      case 'items': {
        if (isAllItemsOption(filter)) {
          setState((prev) => {
            return {
              ...prev,
              filters: {
                ...prev.filters,
                items: { value: [] },
              },
              filtersDraft: {
                ...prev.filtersDraft,
                items: { value: [] },
              },
            };
          });
          break;
        }

        let set_array = (state.filters.items.value || []).filter(
          (item: string) => !isAllItemsOption(item)
        );

        if (set_array.includes(filter)) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        setState((prev) => {
          return {
            ...prev,
            filters: {
              ...prev.filters,
              items: {
                ...prev.filters.items,
                value: set_array,
              },
            },
            filtersDraft: {
              ...prev.filtersDraft,
              items: {
                ...prev.filtersDraft.items,
                value: set_array,
              },
            },
          };
        });
        break;
      }
      default:
        return;
    }
  };

  const handleClearAllFilterDraft = (filter_field: any) => {
    switch (filter_field) {
      case 'rooms':
      case 'items':
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee':
        setState((prev) => {
          return {
            ...prev,
            filtersDraft: {
              ...prev.filtersDraft,
              [filter_field]: {
                ...prev.filtersDraft[filter_field],
                value: [],
              },
            },
          };
        });
        break;
      default:
        return;
    }
  };

  const handleChooseFilterDraft = (filter: string, filter_field: any) => {
    switch (filter_field) {
      case 'rooms':
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee': {
        let set_array = state.filtersDraft[filter_field].value || [];

        if (
          state.filtersDraft[filter_field] &&
          state.filtersDraft[filter_field].value &&
          state.filtersDraft[filter_field].value.includes(filter)
        ) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        setState((prev) => {
          return {
            ...prev,
            filtersDraft: {
              ...prev.filtersDraft,
              [filter_field]: {
                ...prev.filtersDraft[filter_field],
                value: set_array,
              },
            },
          };
        });
        break;
      }
      case 'items': {
        if (isAllItemsOption(filter)) {
          setState((prev) => {
            return {
              ...prev,
              filtersDraft: {
                ...prev.filtersDraft,
                items: { value: [] },
              },
            };
          });
          break;
        }

        let set_array = (state.filtersDraft.items.value || []).filter(
          (item: string) => !isAllItemsOption(item)
        );

        if (set_array.includes(filter)) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        setState((prev) => {
          return {
            ...prev,
            filtersDraft: {
              ...prev.filtersDraft,
              items: {
                ...prev.filtersDraft.items,
                value: set_array,
              },
            },
          };
        });
        break;
      }
      default:
        return;
    }
  };

  const handleSaveComponents = async (components: any) => {
    for (const c of components) {
      await editDraperyOrderSummaryComponent(c);
    }
  };

  const handleProcessEstimate = () => {
    const { feesData } = state;

    if (hasSemicolonInName(state.client)) {
      handleOpenQuickBooksErrorModal(true);
      return;
    }

    if (feesData && feesData.length > 0) {
      handleOpenFeesModal();
    } else {
      handleBatchEstimate();
    }
  };

  const handleBatchEstimate = () => {
    if (Array.isArray(state.singleOrder) && state.singleOrder.length) {
      handleEstimate(state.singleOrder, 'kebab');
    } else {
      handleEstimate(state.checkedProjects, 'batch');
    }
  };

  const handleEstimate = async (ids: number[], source?: 'kebab' | 'batch' | string) => {
    if (!state.accountCanSeePricing) {
      return;
    }
    if (hasSemicolonInName(state.client)) {
      handleOpenQuickBooksErrorModal(true);
      return;
    }

    const selectedNumber = ids.length;
    const ordersWithoutWO = ids.filter((id) => {
      const matchingProject = state.projectList.find((project) => project.id === id);

      if (!matchingProject) {
        return false;
      }

      if (matchingProject.orderType === 'purchased-goods') {
        return false; // purchased goods do not require a work order before export
      }

      return !matchingProject.workOrderId;
    });
    const notReadyOrders = ordersWithoutWO.length;

    trackView(MixpanelEvents.QB_EXPORT, {
      action: 'attempt',
      source: source || 'unknown',
      items_number: selectedNumber,
      notReadyOrders,
    });

    if (notReadyOrders) {
      setState({
        isExportConfirmationModalOpen: true,
        selectedNumber,
        notReadyOrders,
        ordersWithoutWO,
      });
      trackView(MixpanelEvents.QB_EXPORT, {
        action: 'blocked_missing_work_orders',
        source: source || 'unknown',
        items_number: selectedNumber,
        notReadyOrders,
      });
      return;
    }
    setState({ singleOrder: ids });
    if (Array.isArray(state.feesData) && state.feesData.length) {
      handleOpenFeesModal();
    }
    if (
      state.feesModalActive ||
      (!state.feesModalActive && !(Array.isArray(state.feesData) && state.feesData.length))
    ) {
      continueExporting(ids, source);
    }
  };

  const handleModalCancel = () => {
    setState({
      isExportConfirmationModalOpen: false,
      selectedNumber: 0,
      notReadyOrders: 0,
      ordersWithoutWO: [],
    });
  };

  const handleModalContinue = () => {
    const { ordersWithoutWO } = state;
    const readyIds = state.checkedProjects.filter((id) => !ordersWithoutWO.includes(id));

    setState({
      isExportConfirmationModalOpen: false,
      selectedNumber: 0,
      notReadyOrders: 0,
      ordersWithoutWO: [],
    });

    continueExporting(readyIds);
  };

  const continueExporting = async (
    idsToExport: number[],
    source?: 'kebab' | 'batch' | string,
    options?: { forceNoBundling?: boolean; feesOverride?: number[] }
  ) => {
    if (!idsToExport.length) {
      setState({ exportingEstimateLoading: false });
      // Track noop (nothing to export)
      trackView(MixpanelEvents.QB_EXPORT, {
        action: 'noop_no_ids',
        source: source || 'unknown',
        items_number: 0,
        status: 200,
      });
      return;
    }

    const feesForExport = options?.feesOverride ?? state.selectedFees;
    const forceNoBundling = options?.forceNoBundling ?? false;

    setState({ exportingEstimateLoading: true });
    try {
      const res = await quickbooksCheckIsConnected(props.accountId);
      const { dispatch } = props;

      if (res.connected === true && res.userinfo) {
        const exportRes = await exportEstimate(
          idsToExport,
          props.accountId,
          feesForExport,
          forceNoBundling
        );

        if (!exportRes.error) {
          if (idsToExport.length === 1) {
            const project = [...state.projectList].find((p) => p.itemId === idsToExport[0]);
            if (project) {
              const newValues = {
                ...project,
                estimateDateSent: new Date(),
                estimateStatus: 'Exported to QB',
                qbEstimateNumber: exportRes.result.Estimate.DocNumber,
              };
              await editProjectItem(newValues);
            }
          } else {
            const projects = [...state.projectList].filter((p) => idsToExport.includes(p.itemId));
            const promises = projects.map(async (p) => {
              const newValues = {
                ...p,
                estimateDateSent: new Date(),
                estimateStatus: 'Exported to QB',
                qbEstimateNumber: exportRes.result.Estimate.DocNumber,
              };
              return await editProjectItem(newValues);
            });
            await Promise.all(promises);
          }

          loadProjects();
          setState({
            selectedFees: [],
            isEstimateModalOpen: true,
            checkedProjects: [],
            qbEstimateId: exportRes.estimateId,
            exportingEstimateLoading: false,
            qbEstimateDocNumber:
              exportRes.result && exportRes.result.Estimate && exportRes.result.Estimate.DocNumber
                ? exportRes.result.Estimate.DocNumber
                : '',
            bundleSetupPendingIds: [],
            bundleSetupPendingFees: [],
            bundleSetupSource: undefined,
            bundleSetupMissingItems: [],
          });

          trackView(MixpanelEvents.QB_EXPORT, {
            action: 'result',
            source: source || 'unknown',
            items_number: idsToExport.length,
            status: 200,
            estimateId: exportRes.estimateId || undefined,
            docNumber:
              exportRes &&
              exportRes.result &&
              exportRes.result.Estimate &&
              exportRes.result.Estimate.DocNumber
                ? String(exportRes.result.Estimate.DocNumber)
                : undefined,
          });
        } else if (isQuickBooksBundleSetupRequired(exportRes)) {
          setState({
            exportingEstimateLoading: false,
            isBundleSetupModalOpen: true,
            bundleSetupMissingItems: exportRes.missingBundleItems || [],
            bundleSetupPendingIds: idsToExport,
            bundleSetupPendingFees: feesForExport,
            bundleSetupSource: source,
          });

          trackView(MixpanelEvents.QB_EXPORT, {
            action: 'result',
            source: source || 'unknown',
            items_number: idsToExport.length,
            status: 409,
            errorMessage: 'QuickBooks bundle setup required',
          });
        } else {
          setState({ exportingEstimateLoading: false });
          const notification: NotificationsModule.AddNotificationPayload = {
            message: getQuickBooksOnlineErrorTitle(exportRes) || 'Error!',
            subMessage: `${exportRes.message}`,
            type: 'error',
            source: getQuickBooksOnlineNotificationSource(exportRes),
          };
          dispatch(NotificationsModule.addNotification(notification));

          trackView(MixpanelEvents.QB_EXPORT, {
            action: 'result',
            source: source || 'unknown',
            items_number: idsToExport.length,
            status: 500,
            errorMessage: String(exportRes.message || 'Unknown error'),
          });
        }
      } else {
        props.history.push('/quickbooks_connect');
        setState({ exportingEstimateLoading: false });

        trackView(MixpanelEvents.QB_EXPORT, {
          action: 'not_connected_redirect',
          source: source || 'unknown',
          items_number: idsToExport.length,
          status: 500,
          errorMessage: 'QuickBooks not connected',
        });
      }
    } catch (error: any) {
      setState({ exportingEstimateLoading: false });
      const notification: NotificationsModule.Notification = {
        id: 0,
        message: 'Network Error',
        subMessage: 'Could not connect to the server.',
        type: 'error',
      };
      props.dispatch(NotificationsModule.addNotification(notification));

      trackView(MixpanelEvents.QB_EXPORT, {
        action: 'result',
        source: source || 'unknown',
        items_number: idsToExport.length,
        status: 500,
        errorMessage: String((error && error.message) || error || 'Network error'),
      });
    } finally {
      setState({ singleOrder: [] });
      handleCloseFeesModal();
    }
  };

  const handleResetAllFilters = () => {
    setState((prev) => {
      return {
        ...prev,
        filters: {
          rooms: { value: [] },
          items: { value: [] },
          status: { value: [] },
          estimate: { value: [] },
          invoice: { value: [] },
          assignee: { value: [] },
        },
        filtersDraft: {
          rooms: { value: [] },
          items: { value: [] },
          status: { value: [] },
          estimate: { value: [] },
          invoice: { value: [] },
          assignee: { value: [] },
        },
      };
    });
  };

  const handleColumnVisibilityChange = (next: ProjectOverviewColumnVisibility) => {
    const resolvedNext = resolveColumnVisibility(next);
    setState({ columnVisibility: resolvedNext });
    void upsertColumnVisibilityPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.singleProject,
      visibility: { columns: resolvedNext },
    }).catch((error) => {
      console.error('Failed to save column visibility preferences for single-project page:', error);
    });
  };

  const handleSaveCustomColumns = async (customColumns: CustomColumnPreference[]) => {
    if (!props.accountId) {
      return;
    }

    const response = await saveCustomColumnsPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.singleProject,
      customColumns,
    });

    setCustomColumnsConfig(
      Array.isArray(response?.visibility?.customColumns)
        ? response.visibility.customColumns
        : customColumns
    );
  };

  const handleRoleColumnVisibilityChange = (next: Record<number, boolean>) => {
    setRoleColumnVisibility(next);
    void upsertColumnVisibilityPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.singleProject,
      visibility: { assignmentColumns: next },
    }).catch((error) => {
      console.error('Failed to save assignment column visibility for single-project page:', error);
    });
  };

  const handleResetAllFiltersDraft = () => {
    setState((prev) => {
      return {
        ...prev,
        filtersDraft: {
          rooms: { value: [] },
          items: { value: [] },
          status: { value: [] },
          estimate: { value: [] },
          invoice: { value: [] },
          assignee: { value: [] },
        },
      };
    });
  };

  const handleApplyFilters = () => {
    setState((prev) => {
      return {
        ...prev,
        filters: {
          rooms: { value: [...(prev.filtersDraft.rooms?.value || [])] },
          items: { value: [...(prev.filtersDraft.items?.value || [])] },
          status: { value: [...(prev.filtersDraft.status?.value || [])] },
          estimate: { value: [...(prev.filtersDraft.estimate?.value || [])] },
          invoice: { value: [...(prev.filtersDraft.invoice?.value || [])] },
          assignee: { value: [...(prev.filtersDraft.assignee?.value || [])] },
        },
      };
    });
  };

  const updateNotebook = (projId: number, filterOut: string) => {
    if (!projId) return;
    let foundProj: any = state?.projectList?.find((i) => i.id === projId);
    if (!foundProj) return;
    let notebook = foundProj?.notebook || [];
    let filteredNotebook = notebook?.filter((i: any) => i.type !== filterOut);
    foundProj.notebook = filteredNotebook || [];

    setState((prev) => {
      return {
        ...prev,
        projectList: prev.projectList?.map((item: any) => {
          if (item?.id === foundProj?.id) {
            return foundProj;
          }
          return item;
        }),
      };
    });
  };

  const handleChangeValueSearchInput = (e: ChangeEvent<HTMLInputElement>): void => {
    setState({ searchTerm: e.currentTarget.value });
  };

  const handleClearSearchKeyword = (): void => {
    setState({ searchTerm: '' });
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const normalizeFilterValue = (value: unknown): string =>
    String(value ?? '')
      .trim()
      .toLowerCase();

  const normalizeFilterValues = (values: unknown): string[] =>
    Array.isArray(values)
      ? values.map((value) => normalizeFilterValue(value)).filter((value) => value.length > 0)
      : [];

  const normalizeItemFilterToken = (value: unknown): string => {
    const normalized = normalizeFilterValue(value);
    if (!normalized) return normalized;

    if (
      normalized === 'drapery' ||
      normalized === 'drapery-order' ||
      normalized === 'drapery order'
    ) {
      return 'drapery';
    }
    if (
      normalized === 'roman-shade' ||
      normalized === 'roman-shade-order' ||
      normalized === 'roman shade order'
    ) {
      return 'roman shade';
    }
    if (normalized === 'custom-order' || normalized === 'custom order' || normalized === 'other') {
      return 'other';
    }
    if (normalized === 'purchased goods' || normalized === 'purchased-goods') {
      return 'purchased goods';
    }

    return normalized;
  };

  const getProjectRoomFilterValue = (project: any): string =>
    normalizeFilterValue(project?.roomName || project?.customRoom || project?.room);

  const getProjectItemFilterValues = (project: any): string[] => {
    const values = new Set<string>();
    const addValue = (value: unknown) => {
      const normalized = normalizeItemFilterToken(value);
      if (normalized) values.add(normalized);
    };

    addValue(project?.itemType);
    addValue(project?.item);
    addValue(project?.purchasedGoodsItemType?.name);

    const orderType = normalizeFilterValue(project?.orderType);
    if (orderType === 'drapery-order') addValue('drapery');
    if (orderType === 'roman-shade-order') addValue('roman shade');
    if (orderType === 'custom-order') addValue('other');
    if (orderType === 'purchased-goods') addValue('purchased goods');

    return Array.from(values);
  };

  const projectMatchesFilters = (project: any): boolean => {
    const roomsFilter = normalizeFilterValues(state.filters?.rooms?.value);
    const rawItemsFilter = normalizeFilterValues(state.filters?.items?.value);
    const itemsFilter = rawItemsFilter
      .filter((value) => !isAllItemsOption(value))
      .map((value) => normalizeItemFilterToken(value));
    const statusFilter = normalizeFilterValues(state.filters?.status?.value);
    const assigneeFilter = canUseRoleAssignments
      ? Array.isArray(state.filters?.assignee?.value)
        ? state.filters.assignee.value
            .map((value: unknown) =>
              String(value || '')
                .trim()
                .toLowerCase()
            )
            .filter((value: string) => value.length > 0)
        : []
      : [];

    if (roomsFilter.length > 0 && !roomsFilter.includes(getProjectRoomFilterValue(project))) {
      return false;
    }

    if (itemsFilter.length > 0) {
      const projectItemValues = getProjectItemFilterValues(project);
      const matchesItemFilter = itemsFilter.some((item) => projectItemValues.includes(item));
      if (!matchesItemFilter) {
        return false;
      }
    }

    if (statusFilter.length > 0 && !statusFilter.includes(normalizeFilterValue(project?.status))) {
      return false;
    }

    if (assigneeFilter.length > 0) {
      const assignmentKeys = getAssignmentOwnerKeys(project?.assignments).map((key) =>
        key.toLowerCase()
      );
      const matchesAssignee = assigneeFilter.some((key: string) => assignmentKeys.includes(key));
      if (!matchesAssignee) {
        return false;
      }
    }

    return true;
  };

  const projectMatchesSearch = (project: any, normalizedTerm: string): boolean => {
    if (!normalizedTerm) return true;

    const baseValues = [
      project?.itemType,
      project?.item,
      project?.roomName,
      project?.customRoom,
      project?.status,
      project?.notes,
      project?.workOrderNum,
      project?.workOrderId,
      project?.estimateNumber,
      project?.estimateStatus,
      project?.qbEstimateNumber,
      project?.invoiceNumber,
      project?.invoicePaid,
      project?.installNumber,
      project?.installDate,
      project?.window,
      project?.location,
      project?.purchasedGoodsItemType?.name,
      project?.purchasedGoodsSupplier?.displayName,
      project?.purchasedGoodsNotes,
      project?.purchasedGoodsWindowLocationId,
    ];

    const searchableText = [...baseValues]
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value).toLowerCase())
      .join(' ');

    return searchableText.includes(normalizedTerm);
  };
  const componentWillUnmount = () => {
    document.removeEventListener('mousedown', handleClickOutside);
    if (typeof window !== 'undefined') {
      window.removeEventListener(QUIPA_ASSISTANT_CLOSED_EVENT, handleAssistantClosed);
    }
    window.removeEventListener('resize', handleResize);
  };

  const handleResize = () => {
    if (typeof window === 'undefined') return;
    const isMobile = window.innerWidth <= 768;
    if (isMobile !== state.isMobile) {
      setState({ isMobile });
    }
  };

  // handleCloseDropdown(event: any) {
  //   let ref_name = '';
  //   switch (state.filter_dropdown) {
  //     case 'rooms_filter':
  //       ref_name = 'rooms';
  //       break;
  //     case 'items_filter':
  //       ref_name = 'items';
  //       break;
  //     case 'status_filter':
  //       ref_name = 'status';
  //       break;
  //     default:
  //       break;
  //   }
  //   const ref = dropdown[ref_name];
  //   if (ref && ref.current && !ref.current.contains(event.target)) {
  //     setState((prev) => ({ ...prev, filter_dropdown: '' }));
  //   }
  // }

  const handleChooseTableType = (type: string) => {
    if (
      (type === 'fees' || type === 'estimating' || type === 'pos') &&
      !state.accountCanSeePricing
    ) {
      setState((prev) => ({ ...prev, table_type: 'items' }));
      return;
    }
    if (type === 'items') {
      handleTriggerProjectRefetch();
    } else if (type === 'fees') {
      handleTriggerFeesRefetch();
    }
    setState((prev) => ({ ...prev, table_type: type || 'items' }));
  };

  const handleLinkedPOValue = (val: string) => {
    if (!val) {
      const params = new URLSearchParams(window.location.search);
      params.delete('openPo');
      const newUrl = `${window.location.pathname}${params.toString() ? '?' + params : ''}`;
      history.replaceState(null, '', newUrl);
    }
    setOpenLinkedPO(val);
  };

  const handleLinkedPO = (val: string, type: string) => {
    handleLinkedPOValue(val);
    handleChooseTableType(type);
  };

  useEffect(() => {
    if (!state.accountCanSeePricing && ['fees', 'estimating', 'pos'].includes(state.table_type)) {
      setState((prev) => ({ ...prev, table_type: 'items' }));
    }
  }, [state.accountCanSeePricing, state.table_type, setState]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const tableType = String(params.get('tableType') || '').trim();
    if (!tableType) return;

    const allowed = ['items', 'fees', 'estimating', 'ordering-receiving'];
    if (!allowed.includes(tableType)) return;
    if (!state.accountCanSeePricing && ['fees', 'estimating', 'pos'].includes(tableType)) return;
    setState((prev) => (prev.table_type === tableType ? prev : { ...prev, table_type: tableType }));

    // Consume deep-link tableType once so users can switch tabs normally afterward.
    params.delete('tableType');
    props.history.replace({
      pathname: props.location.pathname,
      search: params.toString() ? `?${params.toString()}` : '',
      hash: props.location.hash,
    });
  }, [
    props.history,
    props.location.hash,
    props.location.pathname,
    props.location.search,
    state.accountCanSeePricing,
    setState,
  ]);

  const handleClickOutside = (event: MouseEvent): void => {
    if (!isSubmenuOpenedRef.current) return;
    if (submenuRef && submenuRef.current && !submenuRef.current.contains(event.target as Node)) {
      setState({ isSubmenuOpened: false });
    }
  };

  const handleOpenFeesModal = () => {
    const filtered_items = state.feesData.filter((f: any) => f.item);
    setState((prev) => ({ ...prev, feesModalActive: true, feesData: filtered_items }));
  };

  const handleCloseFeesModal = () => {
    setState((prev) => {
      return {
        ...prev,
        feesModalActive: false,
        selectedFees: [],
        singleOrder: [],
        feesFilter: { status: '' },
      };
    });
    handleTriggerFeesRefetch();
  };

  const handleOpenQuickBooksErrorModal = (val: boolean) => {
    setState((prev) => ({ ...prev, quickBooksErrorModal: val }));
  };

  const handleCloseBundleSetupModal = () => {
    setState({
      isBundleSetupModalOpen: false,
      bundleSetupMissingItems: [],
      bundleSetupPendingIds: [],
      bundleSetupPendingFees: [],
      bundleSetupSource: undefined,
    });
  };

  const handleRetryBundleExport = () => {
    const { bundleSetupPendingIds, bundleSetupPendingFees, bundleSetupSource } = state;

    if (!bundleSetupPendingIds.length) {
      handleCloseBundleSetupModal();
      return;
    }

    handleCloseBundleSetupModal();
    continueExporting(bundleSetupPendingIds, bundleSetupSource, {
      feesOverride: bundleSetupPendingFees,
    });
  };

  const handleExportWithoutBundling = () => {
    const { bundleSetupPendingIds, bundleSetupPendingFees, bundleSetupSource } = state;

    if (!bundleSetupPendingIds.length) {
      handleCloseBundleSetupModal();
      return;
    }

    handleCloseBundleSetupModal();
    continueExporting(bundleSetupPendingIds, bundleSetupSource, {
      forceNoBundling: true,
      feesOverride: bundleSetupPendingFees,
    });
  };

  const handleCloseInvitePanel = () => {
    setIsInvitePanelOpen(false);
    setOpenPermissionTooltip(null);
  };

  const ensureCanManageTeamMembers = (): boolean => {
    if (canManageTeamMembers) {
      return true;
    }
    showErrorToast('You do not have permission to edit team members.');
    return false;
  };

  const getUsedAssigneeLabels = (excludeAssigneeId?: number): Set<string> =>
    collectUsedLabels(teamMembers, pendingInvitations, assigneesWithoutLogin, excludeAssigneeId);

  const fetchAssignees = async (scopeAccountId: number = assigneeScopeAccountId) => {
    if (!scopeAccountId) {
      setAssigneesWithoutLogin([]);
      return;
    }

    try {
      const assignees = await getAllAssigneesByAccountId({ accountId: scopeAccountId });
      setAssigneesWithoutLogin((assignees || []).map(mapAssigneePayloadToRow));
    } catch (error) {
      showErrorToast('Failed to fetch assignees. Please try again later.');
    }
  };

  const loadSeatUsage = async () => {
    if (!managedAccountId) {
      return;
    }

    try {
      const planInfoRes = await getCustomerPlanInfo(managedAccountId);
      let planInfo = planInfoRes['main'];
      let planInfoSeat = planInfoRes['seat'];

      if (!planInfoRes || planInfoRes.error || !planInfo) {
        return;
      }
      if (typeof planInfo.planName === 'string') {
        setPlanName(planInfo.planName);
      }
      let mainPlanInfo = extractSeatLimitFromPlanInfo(planInfo);
      let seatsSum = (planInfoSeat?.quantity || 0) + mainPlanInfo;
      setAvailableSlots(seatsSum);
    } catch (error) {
      // Seat usage is supplemental UI data; keep page functional if unavailable.
      console.error('Failed to load seat usage:', error);
    }
  };

  const fetchTeamData = async () => {
    if (!prevPropsRef?.current?.accountId) {
      return;
    }

    try {
      const user = await getUser({
        accountId: prevPropsRef?.current?.accountId,
        includeTeamData: true,
      });
      const ownerAccountId = resolveOwnerAccountIdFromTeamContext(
        user?.teamContext,
        ownerAccountIdFromStorage || managedAccountId || prevPropsRef?.current?.accountId
      );

      if (ownerAccountId && ownerAccountId !== managedAccountId) {
        setTeamScopeAccountId(ownerAccountId);
      }

      const allTeamMembers = Array.isArray(user?.teamContext?.teamMembers)
        ? user.teamContext.teamMembers
        : [];
      const members = allTeamMembers.filter(
        (member: any) => String(member?.type || '').toLowerCase() === 'subscribed'
      );

      const mappedMembers: TeamMemberRow[] = members.map((member: any) => ({
        id: !!member?.isOwner ? 'owner' : `account-${Number(member?.accountId || 0)}`,
        accountId: Number(member?.accountId || 0),
        firstName: String(member?.firstName || '').trim(),
        lastName: String(member?.lastName || '').trim(),
        email: String(member?.email || '').trim(),
        label: normalizeAssigneeLabelInput(String(member?.label || '').toUpperCase()),
        roles: normalizeRoleIds(member?.roles),
        isOwner: !!member?.isOwner,
        isAdmin: !!member?.isAdmin,
        pricingEnabled: !!member?.canSeePricing,
      }));

      let resolvedTeamMembers: TeamMemberRow[] = mappedMembers;
      if (mappedMembers.length === 0) {
        const fallbackIsOwner =
          !!user?.isOwner ||
          (ownerAccountId > 0 && ownerAccountId === prevPropsRef?.current?.accountId);
        const fallbackIsAdmin = !!user?.isAdmin;
        resolvedTeamMembers = [
          {
            id: 'owner',
            accountId: ownerAccountId || prevPropsRef?.current?.accountId,
            firstName,
            lastName,
            email: String(user?.email || '').trim(),
            label: normalizeAssigneeLabelInput(String(user?.label || '').toUpperCase()),
            roles: normalizeRoleIds(user?.roles),
            isOwner: fallbackIsOwner,
            isAdmin: fallbackIsAdmin,
            pricingEnabled: !!user?.canSeePricing,
          },
        ];
      }
      // setTeamMembers(resolvedTeamMembers);
      setTeamMemberPermissionBaseline(
        resolvedTeamMembers.reduce<Record<string, TeamMemberPermissionDraft>>((acc, member) => {
          acc[member.id] = {
            accountId: member.accountId,
            pricingEnabled: member.pricingEnabled,
            isAdmin: member.isAdmin,
          };
          return acc;
        }, {})
      );
      setPendingTeamMemberPermissions({});

      const ownerMember = mappedMembers.find((member) => member.isOwner);
      const ownerMemberSource = allTeamMembers.find(
        (member: any) => Number(member?.accountId) === ownerMember?.accountId
      );
      const ownerEmailFromContext =
        typeof user?.teamContext?.owner?.email === 'string' ? user.teamContext.owner.email : '';
      const currentUserEmail = typeof user?.email === 'string' ? user.email : '';
      setOwnerEmail(
        String(ownerMemberSource?.email || ownerEmailFromContext || currentUserEmail || '').trim()
      );

      const invitations = Array.isArray(user?.teamContext?.pendingInvitations)
        ? user.teamContext.pendingInvitations
        : [];
      const pendingInvitationsCount = invitations.length;
      setPendingSlots(pendingInvitationsCount);
      const ownerExistsInTeam = mappedMembers.some((member) => member.isOwner);
      const activeTeamMembersCount =
        mappedMembers.length > 0 ? mappedMembers.length + (ownerExistsInTeam ? 0 : 1) : 1;
      setUsedSlots(activeTeamMembersCount + pendingInvitationsCount);
      setPendingInvitations(
        invitations.map((invitation: any) => ({
          id: `pending-account-${Number(invitation?.accountId || 0)}`,
          accountId: Number(invitation?.accountId || 0),
          email: String(invitation?.email || '').trim(),
          label: normalizeAssigneeLabelInput(String(invitation?.label || '').toUpperCase()),
          roleIds: normalizeRoleIds(invitation?.roles),
          sentLabel: formatTimeAgo(invitation?.createdAt),
          statusLabel: 'Pending',
          isAdmin: !!invitation?.isAdmin,
          canSeePricing: !!invitation?.canSeePricing,
        }))
      );
    } catch (error) {
      console.error('Failed to load team settings data:', error);
    }
  };

  const handleSubmitInvitePanel = async () => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    if (invitePanelMode === 'team_member') {
      if (isSeatLimitReached) {
        showErrorToast('Seat limit reached. Add seats before inviting more team members.');
        return;
      }
      if (isInvitingMember) {
        return;
      }
      const trimmedEmail = memberEmail.trim();
      if (!trimmedEmail || !trimmedEmail.includes('@')) {
        showErrorToast('Please enter a valid email.');
        return;
      }
      if (!prevPropsRef?.current?.accountId) {
        showErrorToast('Account not found.');
        return;
      }

      try {
        setIsInvitingMember(true);
        await inviteMember({
          accountId: prevPropsRef?.current?.accountId,
          email: trimmedEmail,
          roles: memberSelectedRoleIds,
          canSeePricing: memberPricingAccess,
          isAdmin: memberAdminAccess,
        });
        await Promise.all([fetchTeamData(), loadSeatUsage()]);
        showSuccessToast(`Invitation sent - An invitation has been sent to ${trimmedEmail}`);
        handleCloseInvitePanel();
      } catch (error: any) {
        if (error?.response?.status === 409) {
          showErrorToast('A user with this email address is already a team member.');
        } else if (error?.response?.status === 403) {
          showErrorToast('You do not have permission to invite team members.');
        } else {
          showErrorToast('Failed to send invitation. Please try again later.');
        }
      } finally {
        setIsInvitingMember(false);
      }
      return;
    }

    const trimmedName = assigneeName.trim();
    const trimmedLabel = normalizeAssigneeLabelInput(assigneeLabel);
    if (!trimmedName) {
      showErrorToast('Assignee name is required.');
      return;
    }
    if (!trimmedLabel || trimmedLabel.length < 1 || trimmedLabel.length > 4) {
      showErrorToast('Label must be 1 to 4 characters.');
      return;
    }
    if (getUsedAssigneeLabels().has(trimmedLabel)) {
      showErrorToast('Label is already in use for this account');
      return;
    }
    if (assigneeSelectedRoleIds.length === 0) {
      showErrorToast('Select at least one role for the assignee.');
      return;
    }

    if (!assigneeScopeAccountId) {
      showErrorToast('Account not found.');
      return;
    }

    try {
      setAssigneeMutationState('adding');
      await addNewAssignee({
        accountId: assigneeScopeAccountId,
        name: trimmedName,
        label: trimmedLabel,
        roles: assigneeSelectedRoleIds,
      });
      await fetchAssignees();
      showSuccessToast(`Assignee added - ${trimmedName} has been added as assignee`);
      handleCloseInvitePanel();
    } catch (error: any) {
      const apiMessage = extractApiErrorMessage(error);
      showErrorToast(apiMessage || 'Failed to add assignee. Please try again later.');
    } finally {
      setAssigneeMutationState(null);
    }
  };

  const resetInvitePanelForm = (mode: InvitePanelMode) => {
    if (mode === 'team_member') {
      setMemberEmail('');
      // setMemberSelectedRoleIds([]);
      setMemberPricingAccess(false);
      setMemberAdminAccess(false);
      return;
    }
    setAssigneeName('');
    setAssigneeLabel('');
    setIsAssigneeLabelAuto(true);
    // setAssigneeSelectedRoleIds([]);
  };

  const handleSwitchInviteMode = (mode: InvitePanelMode) => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    setInvitePanelMode(mode);
    resetInvitePanelForm(mode);
    setOpenPermissionTooltip(null);

    if (mode === 'assignee') {
      void Promise.all([fetchTeamData(), fetchAssignees()]);
    }
  };

  const toggleMemberRole = (roleId: number, checked: boolean) => {
    setMemberSelectedRoleIds((prev) => {
      if (checked) {
        if (prev.includes(roleId)) {
          return prev;
        }
        return [...prev, roleId];
      }
      return prev.filter((id) => id !== roleId);
    });
  };

  const handleChangePlan = async () => {
    try {
      const variant = checkGate(PRICING_TABLE_PLANS_GATE) ? 'new' : 'old';
      const session = await changeSubscriptionPlan(managedAccountId, variant);

      if (session?.url) {
        window.location.href = session.url;
        return;
      }

      const errorMessage = extractApiErrorMessage(session?.error) || session?.message;
      showErrorToast(errorMessage || 'Unable to open change plan page.');
    } catch (error) {
      const errorMessage = extractApiErrorMessage(error);
      showErrorToast(errorMessage || 'Unable to open change plan page.');
    }
  };

  const handleRemoveInactiveMembers = async () => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    if (isRemovingInactiveMembers || resendingInvitationId || deletingInvitationId) {
      return;
    }
    if (pendingInvitations.length === 0) {
      showToast('There is no inactive members');
      return;
    }

    try {
      setIsRemovingInactiveMembers(true);
      const results = await Promise.allSettled(
        pendingInvitations.map((invitation) =>
          updateAccount({
            accountId: invitation.accountId,
            type: 'unsubscribed',
          })
        )
      );

      const failedCount = results.filter((result) => result.status === 'rejected').length;
      const successCount = results.length - failedCount;

      await Promise.all([fetchTeamData(), loadSeatUsage()]);

      if (failedCount > 0) {
        showErrorToast('Failed to remove some inactive members. Please try again later.');
        return;
      }

      const message =
        successCount === 1
          ? '1 inactive member removed.'
          : `${successCount} inactive members removed.`;
      showSuccessToast(message);
    } catch (error) {
      showErrorToast('Failed to remove inactive members. Please try again later.');
    } finally {
      setIsRemovingInactiveMembers(false);
    }
  };

  const isInvitationActionDisabled = (): boolean => {
    return !!deletingInvitationId || !!resendingInvitationId || isRemovingInactiveMembers;
  };

  const handleAssigneeLabelChange = (value: string) => {
    const normalizedLabel = normalizeAssigneeLabelInput(value);
    setAssigneeLabel(normalizedLabel);
    setIsAssigneeLabelAuto(false);
  };

  const toggleAssigneeRole = (roleId: number, checked: boolean) => {
    setAssigneeSelectedRoleIds((prev) => {
      if (checked) {
        if (prev.includes(roleId)) {
          return prev;
        }
        return [...prev, roleId];
      }
      return prev.filter((id) => id !== roleId);
    });
  };

  const getUniqueAssigneeLabel = (name: string): string =>
    generateUniqueAssigneeLabel(name, getUsedAssigneeLabels());

  const handleAssigneeNameChange = (value: string) => {
    setAssigneeName(value);
    if (isAssigneeLabelAuto) {
      setAssigneeLabel(getUniqueAssigneeLabel(value));
    }
  };

  const handleOpenInvitePanel = (mode: InvitePanelMode, role?: any) => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    setInvitePanelMode(mode);
    resetInvitePanelForm(mode);
    setOpenTablePermissionTooltip(null);
    setTablePermissionTooltipPosition(null);
    setIsInvitePanelOpen(true);
    setMemberSelectedRoleIds([role?.id]);
    setAssigneeSelectedRoleIds([role?.id]);

    if (mode === 'assignee') {
      void Promise.all([fetchTeamData(), fetchAssignees()]);
    }
  };
  const handleUpdateTeamMember = async (val: any, member: any, role: any) => {
    if (!member) return;
    if (!role) return;

    let memberRoles: any[] = [];
    if (val) {
      memberRoles = [...new Set([...(member?.roles || []), role?.id])];
    } else if (member?.roles?.length > 0) {
      memberRoles = member?.roles?.filter((f: any) => f !== role?.id);
    }

    const newTeamMembers = teamMembers?.map((i) => {
      if (i?.userId === member?.userId) {
        return {
          ...i,
          roles: memberRoles,
        };
      }
      return i;
    });

    setTeamMembers(newTeamMembers);

    let payload = {
      accountId: member?.accountId,
      roles: memberRoles,
    };

    if (props.handleUpdateTeamMembers) {
      props.handleUpdateTeamMembers(newTeamMembers);
    }

    const res = await updateAccount(payload);
    if (!res) {
      console.error('Error while updating Account');
    }
  };

  const handleUpdateAssignee = async (val: any, assignee: any, role: any) => {
    if (!assignee) return;
    if (!role) return;
    if (!assigneeScopeAccountId) {
      showErrorToast('Account not found.');
      return;
    }

    const previousRoleIds = Array.isArray(assignee?.roles) ? [...assignee.roles] : [];
    const nextRoleIds = val
      ? [...new Set([...(assignee?.roles || []), role?.id])]
      : (assignee?.roles || []).filter((roleId: any) => roleId !== role?.id);

    setAssigneesWithoutLogin((currentAssignees) =>
      currentAssignees.map((currentAssignee) =>
        currentAssignee.id === assignee.id
          ? { ...currentAssignee, roles: [...nextRoleIds] }
          : currentAssignee
      )
    );

    try {
      await editAssignee({
        accountId: assigneeScopeAccountId,
        id: assignee.id,
        roles: [...nextRoleIds],
      });
    } catch (error) {
      setAssigneesWithoutLogin((currentAssignees) =>
        currentAssignees.map((currentAssignee) =>
          currentAssignee.id === assignee.id
            ? { ...currentAssignee, roles: previousRoleIds }
            : currentAssignee
        )
      );
      showErrorToast('Failed to update assignee roles. Please try again later.');
    }
  };

  const handleChangeSeatQty = (e: ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    let numberRegex = /^[1-9]\d*$/;
    if (value && !numberRegex.test(value)) return;

    setSeatState((prev) => {
      return {
        ...prev,
        quantity: value,
      };
    });
  };

  const handleOpenSeatsModal = async (val: boolean) => {
    setOpenSeatsModal(val);
    setIsInvitePanelOpen(false);
    if (val) {
      setSeatLoading(true);
      const res = await getSeatInfo(props.accountId);
      if (res) {
        let defaultIntervalPrice: any = res?.prices?.data?.find(
          (i: any) => i?.recurring?.interval === seatState.interval
        );
        let unit_amount = defaultIntervalPrice?.unit_amount || 0;
        let defaultIntervalCost = unit_amount / 100 || 0;

        setAvailableSeats(res);
        setSeatState((prev) => {
          return {
            ...prev,
            cost: defaultIntervalCost?.toFixed(2),
          };
        });
        setSeatLoading(false);
      }
    } else {
      setAvailableSeats(null);
      setSeatState(initialSeatState);
      setSeatLoading(false);
    }
  };

  const handleChangeInterval = (val: string) => {
    setSeatState((prev) => ({ ...prev, interval: val }));
    let foundInterval = availableSeats?.prices?.data?.find(
      (i: any) => i?.recurring?.interval === val
    );
    let unit_amount = foundInterval?.unit_amount || 0;
    let newCost = unit_amount / 100 || 0;
    setSeatState((prev) => {
      return {
        ...prev,
        cost: newCost?.toFixed(2),
      };
    });
  };

  const handleBuyMoreSeats = async () => {
    setSeatLoading(true);
    let priceObj = availableSeats?.prices?.data?.find(
      (i: any) => i?.recurring?.interval === seatState.interval
    );
    let payload = {
      accountId: props.accountId,
      quantity: Number(seatState.quantity) || 1,
      seat: priceObj,
    };
    const res = await buyAdditionalSeats(payload);
    if (res) {
      setOpenSeatsModal(false);
      setSeatState(initialSeatState);
      await Promise.all([fetchTeamData(), loadSeatUsage()]);
      setSeatLoading(false);
    }
  };

  useEffect(() => {
    if (state?.client) {
      if (!clientProject) return;

      setPills((prev) => {
        return prev.map((item) => {
          let foundItem: any = null;
          if (item?.type === 'status') {
            foundItem = item?.items?.find(
              (f: any) => f?.value === (clientProject?.status || 'New')
            );
          } else if (item?.type === 'estimate') {
            foundItem = item?.items?.find(
              (f: any) =>
                f?.value ===
                (clientProject?.estimateStatusSummary?.status ||
                  clientProject?.estimateStatus ||
                  'Not Created')
            );
          } else if (item?.type === 'invoice') {
            foundItem = item?.items?.find(
              (f: any) => f?.value === (clientProject?.invoiceStatus || 'Not Created')
            );
          } else if (item?.type === 'install' && clientProject?.installDate) {
            let dateValue = new Date(clientProject?.installDate);
            foundItem = {
              id: 1,
              value: dateValue,
              label: moment(dateValue).format('MM/DD/YY'),
            };
          }

          return {
            ...item,
            value: foundItem,
          };
        });
      });

      let projectAssignments = clientProject?.assignments || [];
      if (projectAssignments && projectAssignments?.length <= 0) return;
      setRolePills((prev) => {
        return prev.map((item) => {
          let foundAssignment = projectAssignments?.find((a: any) => a.roleId === item?.id);

          if (foundAssignment) {
            if (!foundAssignment?.accountId && !foundAssignment?.assigneeId) {
              return {
                ...item,
                value: null,
              };
            } else if (foundAssignment?.accountId && !foundAssignment?.assigneeId) {
              let foundItem = item?.items?.find(
                (i: any) =>
                  i?.fakeId?.includes('team_member') && i?.accountId === foundAssignment?.accountId
              );
              return {
                ...item,
                value: foundItem || null,
              };
            } else if (foundAssignment?.assigneeId && !foundAssignment?.accountId) {
              let foundItem = item?.items?.find(
                (i: any) => i?.fakeId?.includes('assignee') && i?.id === foundAssignment?.assigneeId
              );
              return {
                ...item,
                value: foundItem || null,
              };
            }
          }
          return item;
        });
      });
    }
  }, [state?.client]);

  // Client Pills
  const handleChoosePill = async (name: string, pill: any, item: any) => {
    if (name === 'rolePill') {
      let tempApiVal: any = null;
      setRolePills((prev) => {
        return prev.map((i) => {
          if (i.id === pill.id) {
            tempApiVal = i?.value && i?.value?.fakeId === item?.fakeId ? null : item;
            return {
              ...i,
              value: i?.value && i?.value?.fakeId === item?.fakeId ? null : item,
            };
          }
          return i;
        });
      });
      // Payload for API
      let payloadId = clientProject?.id;
      if (!payloadId) return;
      if (!state.client) return;
      if (!managedAccountId) return;
      let payload = {
        payloadId: payloadId,
        accountId: managedAccountId,
        client: state.client,
      };
      payload['assignments'] =
        rolePills?.map((rp) => {
          if (rp?.id === pill?.id) {
            return {
              roleId: rp?.id || null,
              accountId: item?.fakeId?.includes('assignee') ? null : tempApiVal?.accountId || null,
              assigneeId: item?.fakeId?.includes('assignee') ? tempApiVal?.id || null : null,
            };
          }
          return {
            roleId: rp?.id || null,
            accountId: rp?.value?.fakeId?.includes('assignee')
              ? null
              : rp?.value?.accountId || null,
            assigneeId: rp?.value?.fakeId?.includes('assignee')
              ? rp?.value?.assigneeId || rp?.value?.id || null
              : null,
          };
        }) || [];
      const response = await updateProject(payloadId, payload);
      if (response) {
        showSuccessToast(`Successfully updated projects ${pill?.label} column`);
      }
    } else if (name === 'pill') {
      if (pill?.type === 'estimate') return;

      let tempValue: any = null;
      setPills((prev) => {
        return prev.map((i) => {
          if (i.id === pill.id) {
            tempValue =
              pill.type === 'install'
                ? item
                  ? {
                      id: 1,
                      value: item,
                      label: moment(item).format('MM/DD/YY'),
                    }
                  : null
                : item;
            return {
              ...i,
              value: tempValue,
            };
          }
          return i;
        });
      });
      // Payload for API
      let payloadId = clientProject?.id;
      if (!payloadId) return;
      if (!state.client) return;
      if (!managedAccountId) return;
      let payload = {
        payloadId: payloadId,
        accountId: managedAccountId,
        client: state.client,
      };

      if (pill.type === 'status') payload['status'] = tempValue?.value || 'New';
      if (pill.type === 'estimate') payload['estimateStatus'] = tempValue?.value || 'Not Created';
      if (pill.type === 'invoice') payload['invoiceStatus'] = tempValue?.value || 'Not Created';
      if (pill.type === 'install') payload['installDate'] = tempValue?.value || null;

      const response = await updateProject(payloadId, payload);
      if (response) {
        let colMsg = ['estimate', 'invoice'].includes(pill.type)
          ? 'status'
          : pill.type === 'install'
            ? 'date'
            : '';
        showSuccessToast(`Successfully updated projects ${pill.type} ${colMsg}`);
      }
    }
  };
  // Client Pills
  const handleClearPillValue = async (name: string, pill: any) => {
    if (name === 'rolePill') {
      setRolePills((prev) => {
        return prev.map((i) => {
          if (i.id === pill.id) {
            return {
              ...i,
              value: null,
            };
          }
          return i;
        });
      });
      // Payload for API
      let payloadId = clientProject?.id;
      if (!payloadId) return;
      if (!state.client) return;
      if (!managedAccountId) return;
      let payload = {
        payloadId: payloadId,
        accountId: managedAccountId,
        client: state.client,
      };
      payload['assignments'] =
        rolePills?.map((rp) => {
          if (rp?.id === pill?.id) {
            return {
              roleId: rp?.id || null,
              accountId: null,
              assigneeId: null,
            };
          }
          return {
            roleId: rp?.id || null,
            accountId: rp?.value?.fakeId?.includes('assignee')
              ? null
              : rp?.value?.accountId || null,
            assigneeId: rp?.value?.fakeId?.includes('assignee')
              ? rp?.value?.assigneeId || rp?.value?.id || null
              : null,
          };
        }) || [];
      const response = await updateProject(payloadId, payload);
      if (response) {
        showSuccessToast(`Successfully updated projects ${pill?.label} column`);
      }
    } else if (name === 'pill') {
      if (pill?.type === 'estimate') return;

      setPills((prev) => {
        return prev.map((i) => {
          if (i.id === pill.id) {
            return {
              ...i,
              value: null,
            };
          }
          return i;
        });
      });
      // Payload for API
      let payloadId = clientProject?.id;
      if (!payloadId) return;
      if (!state.client) return;
      if (!managedAccountId) return;
      let payload = {
        payloadId: payloadId,
        accountId: managedAccountId,
        client: state.client,
      };

      if (pill.type === 'status') payload['status'] = 'New';
      if (pill.type === 'estimate') payload['estimateStatus'] = 'Not Created';
      if (pill.type === 'invoice') payload['invoiceStatus'] = 'Not Created';
      if (pill.type === 'install') payload['installDate'] = null;

      const response = await updateProject(payloadId, payload);
      if (response) {
        let colMsg = ['estimate', 'invoice'].includes(pill.type)
          ? 'status'
          : pill.type === 'install'
            ? 'date'
            : '';
        showSuccessToast(`Successfully updated projects ${pill.type} ${colMsg}`);
      }
    }
  };

  // ####### END OF FUNCTIONS #######

  // ####### FETCH FUNCTIONS #######
  const fetchSuppliers = async () => {
    try {
      const params = {
        accountId: managedAccountId,
        isActiveOnly: true,
        includeInactive: false,
        clientId: state.client?.id || state?.clientId || undefined,
        purchasedOrders: true,
      };

      const res = await getSuppliers(params);
      setSuppliers(res || []);
    } catch (error) {
      console.error(error);
      showErrorToast('Failed to load suppliers');
    }
  };

  useEffect(() => {
    if (!managedAccountId || !state.client) return;

    fetchSuppliers();
  }, [managedAccountId, state.client]);

  useEffect(() => {
    if (!managedAccountId || !state.client) return;

    const channel = new BroadcastChannel('supplier-events');

    channel.onmessage = (event) => {
      if (event.data?.type !== 'SUPPLIER_UPDATED') return;

      const updatedSupplier = event.data.supplier;
      if (!updatedSupplier?.id) return;

      setSuppliers((prev) =>
        prev.map((supplier) =>
          Number(supplier.id) === Number(updatedSupplier.id)
            ? { ...supplier, ...updatedSupplier }
            : supplier
        )
      );
    };

    return () => {
      channel.close();
    };
  }, [managedAccountId, state.client]);

  const fetchRoles = async () => {
    if (!managedAccountId) {
      setRoles([]);
      return;
    }

    try {
      const roles = await getAllRolesByAccountId({ accountId: managedAccountId });

      setRoles(roles);
    } catch (error) {
      showErrorToast('Failed to fetch roles. Please try again later.');
    }
  };

  useEffect(() => {
    if (!managedAccountId) {
      return;
    }
    fetchRoles();
    loadSeatUsage();
    fetchTeamData();
  }, [managedAccountId, refetchRoles]);

  const render = (): JSX.Element => {
    const params = new URLSearchParams(window.location.search);
    const projectQuery = params && params.get('project');
    const { client, projectList, roomList, checkedProjects, showArchived } = state;

    const extractedParent = extractParent(client);

    const { onClose, onOtherClientChoosed } = props;
    const numberDelete = projectList.filter((project) =>
      checkedProjects.includes(project.itemId)
    ).length;
    const selectedBatchItemsHaveEstimateConnection = projectList
      .filter(
        (project: any) =>
          checkedProjects.includes(project.itemId) || checkedProjects.includes(project.id)
      )
      .some(
        (project: any) => project?.estimateId || project?.quipaEstimateId || project?.qbEstimateId
      );
    if (!client) {
      return (
        <div data-qa="client-loader">
          <FadeLoader
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(50%,-50%)',
              zIndex: 9999,
              display: client ? 'none' : 'block',
            }}
            color="#3B97B1"
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      );
    }
    // const pdfFilenamePrefix = `${
    //     client.lastName || client.company || client.firstName || "QUIPA"
    // } WO-`;
    console.log('generatePdf', state.generatePdf);

    const hasPurchasedGoods = projectList.some(
      (project) => project?.orderType === 'purchased-goods'
    );
    const itemsMap = buildItemTypeFilterOptions(state.items || [], hasPurchasedGoods).map(
      (item) => ({
        name: item,
        value: item,
      })
    );
    const roomsMap =
      (state.rooms &&
        state.rooms.length > 0 &&
        state.rooms.filter((i) => i.name).sort((a: any, b: any) => a.name.localeCompare(b.name))) ||
      [];

    const roomsFilter = state.filters.rooms.value;
    const itemsFilter = state.filters.items.value;
    const statusFilter = state.filters.status.value;
    const assigneeFilter = canUseRoleAssignments ? state.filters.assignee.value : [];
    const roleAssignmentColumnsForUi = canUseRoleAssignments ? roleAssignmentColumns : [];
    const visibleRoleAssignmentColumns = canUseRoleAssignments
      ? roleAssignmentColumns.filter((role) => roleColumnVisibility[role.id] !== false)
      : [];

    const assigneeFilterItems = buildRoleAssignmentFilterOptions(
      roleAssignmentColumnsForUi,
      assignmentOptionsByRoleId
    ).map((option) => ({
      name: option.label,
      label: option.label,
      value: option.value,
    }));

    const isFiltersActivate =
      (roomsFilter && roomsFilter.length > 0) ||
      (itemsFilter && itemsFilter.length > 0) ||
      (statusFilter && statusFilter.length > 0) ||
      (assigneeFilter && assigneeFilter.length > 0);

    const filteredProjectList = projectList.filter(projectMatchesFilters);
    const normalizedSearchTerm = state.searchTerm.trim().toLowerCase();
    const visibleProjectList = normalizedSearchTerm
      ? filteredProjectList.filter((project) => projectMatchesSearch(project, normalizedSearchTerm))
      : filteredProjectList;

    const activeFilters = () => {
      const keys: Array<'rooms' | 'items' | 'status' | 'assignee'> = canUseRoleAssignments
        ? ['rooms', 'items', 'status', 'assignee']
        : ['rooms', 'items', 'status'];
      return keys.reduce((count, key) => {
        const values = state.filtersDraft?.[key]?.value;
        return Array.isArray(values) && values.length > 0 ? count + 1 : count;
      }, 0);
    };

    const columnVisibilityMenuProps = {
      value: state.columnVisibility,
      onChange: handleColumnVisibilityChange,
      hiddenKeys: ['client'] as ProjectOverviewColumnKey[],
      preserveOnHideAll: ['item'] as ProjectOverviewColumnKey[],
      dataQaPrefix: 'client',
      enableCustomColumns: true,
      showCustomFieldsSection: true,
      canCustomizeCustomColumns,
      initialCustomColumns: customColumnsConfig,
      onSaveCustomColumns: handleSaveCustomColumns,
      roleAssignmentColumns: roleAssignmentColumnsForUi,
      roleColumnVisibility,
      onRoleColumnVisibilityChange: handleRoleColumnVisibilityChange,
      isAccountAdmin: state.accountIsAdmin,
      account,
      handleRefetchRoles,
      teamMembers,
      assignees: assigneesWithoutLogin,
      handleUpdateTeamMember,
      handleUpdateAssignee,
      unsetRoleColumns,
      handleOpenInvitePanel,
      canAccessTeamSettings: props.canAccessTeamSettings,
    };

    const drawerFilters = {
      onResetAll: handleResetAllFiltersDraft,
      onApply: handleApplyFilters,
      activeFilters: activeFilters(),
      isMobile: true,
      disabled: false,
      isFiltersActivate: isFiltersActivate,
      filters: [
        {
          shadcn: true,
          filter_name: 'Rooms',
          filter_key: 'rooms',
          filter_values: state.filtersDraft.rooms.value,
          multiple_select: true,
          dataQaPrefix: 'client',
          items: roomsMap,
          archived: false,
          show_option_all: false,
          handleClearAllFilter: handleClearAllFilterDraft,
          handleChooseFilter: handleChooseFilterDraft,
        },
        {
          shadcn: true,
          filter_name: 'Items',
          filter_key: 'items',
          filter_values: state.filtersDraft.items.value,
          multiple_select: true,
          dataQaPrefix: 'client',
          items: itemsMap,
          archived: true,
          archivedCheckbox: state.showArchived,
          show_option_all: false,
          archivedProjectsFunction: true,
          handleClearAllFilter: handleClearAllFilterDraft,
          handleChooseFilter: handleChooseFilterDraft,
          handleShowArchived: onShowArchiveChange,
        },
        ...(canUseRoleAssignments
          ? [
              {
                shadcn: true,
                filter_name: 'Assignee',
                filter_key: 'assignee',
                filter_values: state.filtersDraft.assignee.value,
                multiple_select: true,
                dataQaPrefix: 'client',
                items: assigneeFilterItems,
                archived: false,
                show_option_all: false,
                handleClearAllFilter: handleClearAllFilterDraft,
                handleChooseFilter: handleChooseFilterDraft,
              },
            ]
          : []),
        {
          shadcn: true,
          filter_name: 'Status',
          filter_key: 'status',
          filter_values: state.filtersDraft.status.value,
          multiple_select: true,
          dataQaPrefix: 'client',
          items: state.accountStatuses,
          archived: false,
          show_option_all: false,
          handleClearAllFilter: handleClearAllFilterDraft,
          handleChooseFilter: handleChooseFilterDraft,
        },
      ],
    };

    const clientAdjustment = getClientPriceAdjustment(client);
    const showClientPriceAdjustmentColumn = shouldShowClientPriceAdjustmentColumn(
      state.feesData || [],
      clientAdjustment
    );
    const feesProps = {
      accountId: props.accountId,
      clientId: props.clientId,
      data: state.feesData,
      feeTypes: state.feeTypes,
      loading: state.loading,
      selectedFees: state.selectedFees,
      handleRefetch: handleTriggerFeesRefetch,
      handleInlineChange: handleInlineChange,
      handleInlineDropdownChange: handleInlineDropdownChange,
      handleCheckAllFeeRows: handleCheckAllFeeRows,
      handleSelectFeeRows: handleSelectFeeRows,
      handleResetCheckedFees: handleResetCheckedFees,
      handleFeeEstimate: handleFeeEstimate,
      isConnected: props.isConnected,
      clientPriceAdjustmentType: clientAdjustment.adjustmentType,
      clientPriceAdjustmentValue: clientAdjustment.adjustmentValue,
      clientHasPriceAdjustment: clientAdjustment.hasAdjustment,
      showClientPriceAdjustmentColumn,
      canOpenEstimate: state.accountCanSeePricing,
      onOpenEstimate: handleOpenEstimateFromStatus,
      onOpenEstimatingTab: () => handleChooseTableType('estimating'),
    };

    const feesModalProps = {
      data: state.feesData,
      active: state.feesModalActive,
      selectedFees: state.selectedFees,
      feesFilter: state.feesFilter,
      exportFunction: handleBatchEstimate,
      cancelFunction: handleCloseFeesModal,
      checkRowFunction: handleSelectFeeRows,
      checkAllRowsFunction: handleCheckAllFeeRows,
      handleFeesFilter: handleFeesFilter,
    };

    const releaseDate = new Date('2026-01-12');
    const thirtyDaysAfterRelease = new Date(releaseDate);
    thirtyDaysAfterRelease.setDate(thirtyDaysAfterRelease.getDate() + 30);

    const showNewBadge = thirtyDaysAfterRelease > new Date();
    const estimatingReleaseDate = new Date('2026-05-12');
    const thirtyDaysAfterEstimatingRelease = new Date(estimatingReleaseDate);
    thirtyDaysAfterEstimatingRelease.setDate(thirtyDaysAfterEstimatingRelease.getDate() + 30);
    const showEstimatingNewBadge = thirtyDaysAfterEstimatingRelease > new Date();

    const posReleaseDate = new Date('2026-05-24');
    const thirtyDaysAfterPOsRelease = new Date(posReleaseDate);
    thirtyDaysAfterPOsRelease.setDate(thirtyDaysAfterPOsRelease.getDate() + 30);
    const showPOsBadge = thirtyDaysAfterPOsRelease > new Date();

    const quickBooksErrorModalProps = {
      active: state.quickBooksErrorModal,
      title: 'Invalid Character in Name',
      onClose: () => handleOpenQuickBooksErrorModal(false),
      actions: [
        {
          buttonClassName: 'link_button',
          title: 'Close',
          action: () => handleOpenQuickBooksErrorModal(false),
        },
      ],
    };

    const posProps = {
      suppliers: suppliers || [],
      client: client || null,
      account: account || null,
      user: props.accountUser || null,
      openLinkedPO: openLinkedPO || '',
      handleLinkedPOValue: handleLinkedPOValue,
      handleTriggerProjectRefetch: handleTriggerProjectRefetch,
    };

    return (
      <CSSTransitionBox>
        <CSSTransition in={state.displayContent} timeout={300} classNames="content" unmountOnExit>
          <ClientInfo onScroll={onAreaScroll} data-qa="client-page">
            <PopoverScrollContext.Provider value={state.areaScrollInfo}>
              {/* {state.workOrderPdfStatus === "downloading" &&
                                state.workOrderPdfContent && (
                                    <DraperyPdf
                                        filename={`${pdfFilenamePrefix}${state.workOrderPdfContent.workOrderNum}`}
                                        workOrderPdfContent={
                                            state.workOrderPdfContent
                                        }
                                        onFinished={
                                            handleDraperyPdfFinished
                                        }
                                    />
                                )} */}
              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between gap-2" data-qa="client-header">
                  <div className="min-w-0 flex-1" data-qa="client-basic-detail">
                    <BasicDetail
                      info={client}
                      detailsDisplayed={state.detailsDisplayed}
                      onToggleDetails={toggleClientDetails}
                      onGoBack={onClose}
                      onAncestorClick={onOtherClientChoosed}
                      onClick={openClientModal}
                      actionsInline
                    />
                  </div>
                </div>

                <div className="relative">
                  <div className="md:hidden absolute right-0 top-0 h-[calc(100%-10px)] w-[15px] bg-gradient-to-r from-transparent to-white z-[1]" />

                  <div className="relative flex md:flex-wrap md:overflow-x-visible overflow-x-auto items-center gap-1.5 md:pr-0 pr-[4px]">
                    {props.canAccessTeamSettings &&
                      rolePills?.length > 0 &&
                      rolePills.map((item) => {
                        let selectedValue = item?.value;
                        let selectedValueDisplayName =
                          selectedValue?.firstName || selectedValue?.lastName
                            ? `${selectedValue?.firstName || ''} ${selectedValue?.lastName || ''}`
                            : selectedValue?.name || '';

                        return (
                          <Popover key={item?.id}>
                            <PopoverTrigger asChild>
                              <Button
                                data-qa={`rolePill_${item?.label?.toLowerCase()}_trigger`}
                                size={'pill'}
                                variant={'pill'}
                                type="button"
                              >
                                <span className="text-[10px] text-muted-foreground whitespace-nowrap">
                                  {item?.label}:
                                </span>
                                <span className="text-[10px] font-medium whitespace-nowrap">
                                  {item?.value ? selectedValueDisplayName : '—'}
                                </span>
                                {!item?.value ? (
                                  <LucideChevronDown className="lucide lucide-chevron-down h-3 w-3 text-muted-foreground" />
                                ) : (
                                  <Button
                                    data-qa={`rolePill_${item?.label?.toLowerCase()}_clear`}
                                    variant={'x_btn'}
                                    size={'x_btn'}
                                    type="button"
                                    onPointerDown={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleClearPillValue('rolePill', item);
                                    }}
                                  >
                                    <LucideX className="lucide lucide-x h-3 w-3" />
                                  </Button>
                                )}
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent align={'start'} className="p-[8px] w-[230px]">
                              <div className="flex flex-col gap-0.5">
                                {item?.items?.length > 0 ? (
                                  item?.items?.map((i: any, idx: number) => {
                                    let itemValueDisplayName =
                                      i?.firstName || i?.lastName
                                        ? `${i?.firstName || ''} ${i?.lastName || ''}`
                                        : i?.name || '';

                                    return (
                                      <button
                                        type="button"
                                        data-qa={`rolePill_${item?.label?.toLowerCase()}_${i?.fakeId}_item`}
                                        data-selected={selectedValue?.fakeId === i?.fakeId}
                                        onClick={() => handleChoosePill('rolePill', item, i)}
                                        className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center justify-between data-[selected=true]:bg-accent"
                                        key={idx}
                                      >
                                        <span className="break-words break-all">
                                          {`${itemValueDisplayName}`} <span>@{i?.label || ''}</span>
                                        </span>

                                        {selectedValue?.fakeId === i?.fakeId && (
                                          <LucideCheck className="shrink-0 lucide lucide-check h-3 w-3 text-primary" />
                                        )}
                                      </button>
                                    );
                                  })
                                ) : (
                                  <div className="leading-normal text-[10px] text-left px-2 py-1.5 rounded flex flex-col gap-2">
                                    <span>No team members with this role</span>
                                    {state.accountIsAdmin && (
                                      <div>
                                        <span>
                                          Add members to role in{' '}
                                          <a href="/team_settings?tab=roles">Team Settings</a>
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </PopoverContent>
                          </Popover>
                        );
                      })}

                    {pills?.length > 0 &&
                      pills.map((item: any, index: number) => {
                        let selectedValue = item?.value;
                        let selectedValueDisplayName = selectedValue?.label;

                        if (item?.readOnly) {
                          return (
                            <Button
                              key={index}
                              data-qa={`pill_${item?.type}_trigger`}
                              size={'pill'}
                              variant={'pill'}
                              type="button"
                              className="cursor-default"
                              aria-readonly="true"
                            >
                              <span className="text-[10px] text-muted-foreground whitespace-nowrap">
                                {item?.label}:
                              </span>
                              <span
                                className={`text-[10px] font-medium whitespace-nowrap ${statusColor(item.type, selectedValue?.value)}`}
                              >
                                {item?.value ? selectedValueDisplayName : 'â€”'}
                              </span>
                            </Button>
                          );
                        }

                        return (
                          <Popover
                            key={index}
                            onOpenChange={(val) => {
                              if (!val) {
                                setNewStatus(false);
                                setNewStatusValue('');
                              }
                            }}
                          >
                            <PopoverTrigger asChild>
                              <Button
                                data-qa={`pill_${item?.type}_trigger`}
                                size={'pill'}
                                variant={'pill'}
                                type="button"
                              >
                                <span className="text-[10px] text-muted-foreground whitespace-nowrap">
                                  {item?.label}:
                                </span>
                                <span
                                  className={`text-[10px] font-medium whitespace-nowrap ${statusColor(item.type, selectedValue?.value)}`}
                                >
                                  {item?.value
                                    ? selectedValueDisplayName
                                    : item?.type === 'install'
                                      ? 'MM/DD/YY'
                                      : '—'}
                                </span>

                                {item?.type === 'install' ? (
                                  !item?.value ? (
                                    <LucideChevronDown className="lucide lucide-chevron-down h-3 w-3 text-muted-foreground" />
                                  ) : (
                                    <Button
                                      data-qa={`pill_${item?.type}_clear`}
                                      variant={'x_btn'}
                                      size={'x_btn'}
                                      type="button"
                                      onPointerDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleClearPillValue('pill', item);
                                      }}
                                    >
                                      <LucideX className="lucide lucide-x h-3 w-3" />
                                    </Button>
                                  )
                                ) : (
                                  <LucideChevronDown className="lucide lucide-chevron-down h-3 w-3 text-muted-foreground" />
                                )}
                              </Button>
                            </PopoverTrigger>
                            {/* STATUS PILL */}
                            {item?.type === 'status' && (
                              <PopoverContent align={'start'} className="p-[8px] w-[200px]">
                                <div className="border-b border-input mb-1 pb-1">
                                  <li
                                    data-qa={`pill_${item?.type}_new_status_trigger`}
                                    onClick={handleSetNewStatus}
                                    className="relative hover:bg-accent flex gap-1 select-none items-center rounded-sm px-2 py-1.5 text-[12px] outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 text-primary cursor-pointer"
                                  >
                                    <span>+</span> New Status
                                  </li>

                                  {newStatus && (
                                    <div className="max-w-[200px] flex items-center gap-2 px-2 py-1.5">
                                      <Input
                                        data-qa={`pill_${item?.type}_new_status_input`}
                                        value={newStatusValue}
                                        onChange={handleChangeNewStatus}
                                        placeholder="Enter Name..."
                                        className="min-h-[0px] outline-none flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-input-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-[12px] h-7 text-xs flex-1"
                                      />
                                      {newStatusValue && (
                                        <Button
                                          data-qa={`pill_${item?.type}_new_status_save`}
                                          onClick={handleSavePillNewStatus}
                                          className="text-primary p-0 m-0 min-h-[max-content] h-[max-content] text-[12px]"
                                          variant={'text'}
                                          type="button"
                                        >
                                          Save
                                        </Button>
                                      )}
                                    </div>
                                  )}
                                </div>

                                <div className="flex flex-col gap-0.5">
                                  {item?.items.map((i: any, idx: number) => {
                                    return (
                                      <button
                                        type="button"
                                        data-qa={`pill_${item?.type}_${i?.id}_item`}
                                        data-selected={selectedValue?.id === i?.id}
                                        className={`leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 hover:text-accent-foreground flex items-center justify-between data-[selected=true]:bg-accent ${statusColor(item?.type, i?.value)}`}
                                        onClick={() => {
                                          if (selectedValue?.id === i?.id) return;
                                          handleChoosePill('pill', item, i);
                                        }}
                                        key={idx}
                                      >
                                        <span className="break-words break-all">
                                          {i?.label || ''}
                                        </span>

                                        {selectedValue?.id === i?.id && (
                                          <LucideCheck className="shrink-0 lucide lucide-check h-3 w-3 text-primary" />
                                        )}
                                      </button>
                                    );
                                  })}
                                </div>
                              </PopoverContent>
                            )}
                            {/* INSTALL DATE PILL */}
                            {item?.type === 'install' && (
                              <PopoverContent align={'start'} className="p-0 min-w-max">
                                <Calendar
                                  selected={selectedValue?.value}
                                  mode="single"
                                  className="rounded-md border-0 p-[12px]"
                                  onSelect={(v) => {
                                    handleChoosePill('pill', item, v);
                                  }}
                                />
                              </PopoverContent>
                            )}
                            {/* OTHER PILLS */}
                            {!['status', 'install'].includes(item?.type) && (
                              <PopoverContent align={'start'} className="p-[8px] w-[200px]">
                                <div className="flex flex-col gap-0.5">
                                  {item?.items?.map((i: any, idx: number) => {
                                    return (
                                      <button
                                        type="button"
                                        data-qa={`pill_${item?.type}_${i?.id}_item`}
                                        data-selected={selectedValue?.id === i?.id}
                                        onClick={() => {
                                          if (selectedValue?.id === i?.id) return;
                                          handleChoosePill('pill', item, i);
                                        }}
                                        className={`leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 hover:text-accent-foreground flex items-center justify-between data-[selected=true]:bg-accent ${statusColor(item?.type, i?.value)}`}
                                        key={idx}
                                      >
                                        <span className="break-words break-all">
                                          {i?.label || ''}
                                        </span>

                                        {selectedValue?.id === i?.id && (
                                          <LucideCheck className="shrink-0 lucide lucide-check h-3 w-3 text-primary" />
                                        )}
                                      </button>
                                    );
                                  })}
                                </div>
                              </PopoverContent>
                            )}
                          </Popover>
                        );
                      })}
                  </div>
                </div>
              </div>

              <ConfirmationModal
                uiActive={state.isModalOpen && state.value === 'Duplicate'}
                uiOnConfirm={() => handleProjectAction('Duplicate')}
                uiOnClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiOnRequestClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
              >
                <p>
                  {`Are you sure you want to duplicate ${numberDelete} ${
                    numberDelete === 1 ? 'item' : 'items'
                  }
                                   ?`}
                </p>
              </ConfirmationModal>

              <ConfirmationModal
                uiActive={state.isModalOpen && state.value === 'Delete'}
                uiOnConfirm={() => handleProjectAction('Delete')}
                uiOnClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiOnRequestClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
              >
                <p>
                  {`Are you sure you want to delete ${numberDelete} ${
                    numberDelete === 1 ? 'item' : 'items'
                  }
                                   ?`}
                </p>
              </ConfirmationModal>
              <WarningModal
                uiActive={state.isModalOpen && state.value === 'DuplicateBlocked'}
                uiOnConfirm={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiOnRequestClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
                uiHeader="Cannot Duplicate"
              >
                <p>
                  {`Some options selected on this Roman Shade Order form are no longer available in our updated form. This order is unable to be duplicated; please create a new order instead.`}
                </p>
              </WarningModal>
              <ConfirmationModal
                uiActive={state.isModalOpen && state.value === 'Archive'}
                uiOnConfirm={() => handleProjectAction('Archive')}
                uiOnClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiOnRequestClose={() => {
                  setState({
                    isModalOpen: false,
                    value: '',
                  });
                }}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
              >
                <p>
                  {`Are you sure you want to archive ${numberDelete} ${
                    numberDelete === 1 ? 'item' : 'items'
                  }
                                   ?`}
                </p>
              </ConfirmationModal>

              {state.detailsDisplayed && (
                <div data-qa="client-more-details">
                  <ClientMoreDetails
                    client={{
                      ...client,
                      billingDetails: client.billToParent
                        ? extractedParent?.billingInfoDirectly || client.billingDetails
                        : client.billingDetailsDirectly || {},
                    }}
                    parentClients={state.parentClients}
                    onSubClientClick={onOtherClientChoosed}
                    createSubClient={createSubClient}
                  />
                </div>
              )}

              {state.table_type === 'items' ? (
                <div style={{ height: '2px', marginBottom: '3px' }} />
              ) : (
                <div style={{ height: '2px', marginBottom: '3px' }} />
              )}

              <div className="filters_container client_filters" data-qa="client-filters">
                <div className="flex justify-between gap-1 w-full flex-wrap">
                  <div className="flex gap-2">
                    <div
                      className="md:inline-flex hidden other_tables client-table-tabs"
                      data-qa="client-table-type-tabs"
                    >
                      <div>
                        <button
                          className={`link_button ${state.table_type === 'items' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handleChooseTableType('items')}
                          data-qa="client-table-type-items"
                        >
                          Items
                        </button>
                      </div>

                      {state.accountCanSeePricing && (
                        <div>
                          <button
                            className={`link_button ${state.table_type === 'fees' ? 'active' : ''}`}
                            type="button"
                            onClick={() => handleChooseTableType('fees')}
                            data-qa="client-table-type-fees"
                          >
                            Fees
                          </button>
                        </div>
                      )}

                      {state.accountCanSeePricing && (
                        <div>
                          <button
                            className={`link_button inline-flex items-center gap-2 ${state.table_type === 'estimating' ? 'active' : ''}`}
                            type="button"
                            onClick={() => handleChooseTableType('estimating')}
                            data-qa="client-table-type-estimating"
                          >
                            Estimating
                            {showEstimatingNewBadge ? <span className="new_pill">New</span> : null}
                          </button>
                        </div>
                      )}

                      <div>
                        <button
                          className={`link_button ${state.table_type === 'ordering-receiving' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handleChooseTableType('ordering-receiving')}
                          data-qa="client-table-type-ordering-receiving"
                        >
                          Ordering & Receiving
                        </button>
                      </div>

                      {state.accountCanSeePricing && (
                        <div>
                          <button
                            className={`link_button inline-flex items-center gap-2 ${state.table_type === 'pos' ? 'active' : ''}`}
                            type="button"
                            onClick={() => handleChooseTableType('pos')}
                            data-qa="client-table-type-pos"
                          >
                            POs
                            {showPOsBadge ? <span className="new_pill">New</span> : null}
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="md:hidden inline-flex">
                      <Popover>
                        <PopoverTrigger asChild>
                          <Button variant={'tabs-selector'} type="button">
                            <span className="inline-flex items-center gap-2">
                              {state.table_type === 'items'
                                ? 'Items'
                                : state.table_type === 'fees'
                                  ? 'Fees'
                                  : state.table_type === 'estimating'
                                    ? 'Estimating'
                                    : state.table_type === 'ordering-receiving'
                                      ? 'Ordering & Receiving'
                                      : state.table_type === 'pos'
                                        ? 'POs'
                                        : 'Items'}
                              {state.table_type === 'items' ? ` (${projectList?.length || 0})` : ''}
                              {state.table_type === 'estimating' && showEstimatingNewBadge ? (
                                <span className="new_pill">New</span>
                              ) : null}
                              {state.table_type === 'pos' && showPOsBadge ? (
                                <span className="new_pill">New</span>
                              ) : null}
                            </span>
                            <LucideChevronDown className="lucide lucide-chevron-down h-4 w-4 opacity-50" />
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent align={'start'} className="p-[8px] w-[200px]">
                          <div className="flex flex-col gap-0.5">
                            <button
                              className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center gap-[8px] data-[selected=true]:bg-accent"
                              type="button"
                              onClick={() => handleChooseTableType('items')}
                              data-qa="client-table-type-items"
                              data-selected={state.table_type === 'items'}
                            >
                              <LucideCheck
                                className={`shrink-0 lucide lucide-check h-4 w-4 ${state.table_type === 'items' ? 'opacity-100' : 'opacity-0'}`}
                              />
                              Items
                            </button>
                          </div>
                          {state.accountCanSeePricing && (
                            <div className="flex flex-col gap-0.5">
                              <button
                                className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center gap-[8px] data-[selected=true]:bg-accent"
                                type="button"
                                onClick={() => handleChooseTableType('fees')}
                                data-qa="client-table-type-fees"
                                data-selected={state.table_type === 'fees'}
                              >
                                <LucideCheck
                                  className={`shrink-0 lucide lucide-check h-4 w-4 ${state.table_type === 'fees' ? 'opacity-100' : 'opacity-0'}`}
                                />
                                Fees
                              </button>
                            </div>
                          )}
                          {state.accountCanSeePricing && (
                            <div className="flex flex-col gap-0.5">
                              <button
                                className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center gap-[8px] data-[selected=true]:bg-accent"
                                type="button"
                                onClick={() => handleChooseTableType('estimating')}
                                data-qa="client-table-type-estimating"
                                data-selected={state.table_type === 'estimating'}
                              >
                                <LucideCheck
                                  className={`shrink-0 lucide lucide-check h-4 w-4 ${state.table_type === 'estimating' ? 'opacity-100' : 'opacity-0'}`}
                                />
                                <span>Estimating</span>
                                {showEstimatingNewBadge ? (
                                  <span className="new_pill">New</span>
                                ) : null}
                              </button>
                            </div>
                          )}
                          <div className="flex flex-col gap-0.5">
                            <button
                              className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center gap-[8px] data-[selected=true]:bg-accent"
                              type="button"
                              onClick={() => handleChooseTableType('ordering-receiving')}
                              data-qa="client-table-type-ordering-receiving"
                              data-selected={state.table_type === 'ordering-receiving'}
                            >
                              <LucideCheck
                                className={`shrink-0 lucide lucide-check h-4 w-4 ${state.table_type === 'ordering-receiving' ? 'opacity-100' : 'opacity-0'}`}
                              />
                              Ordering & Receiving
                            </button>
                          </div>
                          {state.accountCanSeePricing && (
                            <div className="flex flex-col gap-0.5">
                              <button
                                className="leading-normal text-xs text-left px-2 py-1.5 rounded hover:bg-muted/50 flex items-center gap-[8px] data-[selected=true]:bg-accent"
                                type="button"
                                onClick={() => handleChooseTableType('pos')}
                                data-qa="client-table-type-pos"
                                data-selected={state.table_type === 'pos'}
                              >
                                <LucideCheck
                                  className={`shrink-0 lucide lucide-check h-4 w-4 ${state.table_type === 'pos' ? 'opacity-100' : 'opacity-0'}`}
                                />
                                <span>POs</span>
                                {showPOsBadge && <span className="new_pill">New</span>}
                              </button>
                            </div>
                          )}
                        </PopoverContent>
                      </Popover>
                    </div>

                    <Tooltip>
                      <TooltipTrigger>
                        <div
                          title="View Notebook for this project."
                          className="cursor-pointer h-full rounded-md border border-input bg-background hover:bg-muted/50 transition-colors"
                        >
                          <Notebook
                            row={{
                              id: clientProject?.id,
                              notebook: clientProjectNotebook,
                            }}
                            defaultTab="projects"
                            notebookTabs={['projects']}
                            user={props.accountUser}
                            table={'projects'}
                            canAccessTeamSettings={props.canAccessTeamSettings}
                            updateNotebook={updateNotebook}
                            wrapperClassName={'w-full h-full'}
                            triggerClassName={
                              'py-[3px] px-3 w-full h-full md:min-h-[40px] min-h-[36px]'
                            }
                            closeOnOutsideClick={false}
                          />
                        </div>
                      </TooltipTrigger>
                      <TooltipContent
                        side="top"
                        sideOffset={8}
                        className="rounded-[8px] border border-[#D8E0E8] bg-white px-3 py-2 text-[14px] leading-[1.3] text-[#111827] shadow-md"
                        arrowClassName="fill-white"
                        data-qa={`view_notebook_for_this_project_${state?.client?.id}`}
                      >
                        View Notebook for this project.
                      </TooltipContent>
                    </Tooltip>
                  </div>

                  <div>
                    {state.table_type === 'items' && state.accountCanSeePricing && (
                      <div className={'md:flex hidden shrink-0 justify-end items-center'}>
                        <div className="flex flex-col relative" ref={submenuRef}>
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button
                                type="button"
                                onClick={() => {
                                  setState((prev) => ({
                                    ...prev,
                                    isSubmenuOpened: !state.isSubmenuOpened,
                                  }));
                                }}
                                data-qa="client-add-item-button"
                              >
                                <PlusIcon className="lucide lucide-plus w-4 h-4 mr-2" />
                                <span>New Item</span>
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end" className="p-1 w-[220px]">
                              {/* <div className="add_item_submenu" data-qa="client-add-item-menu"> */}
                              <DropdownMenuItem className="p-0 relative flex cursor-default select-none items-center rounded-sm text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 w-full">
                                <button
                                  className="w-full px-2 py-1.5"
                                  onClick={() => {
                                    setState((prev) => ({ ...prev, isSubmenuOpened: false }));
                                    handleNewClientProject('drapery-order');
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                  data-qa="client-add-item-drapery"
                                >
                                  <span>Drapery</span>
                                </button>
                              </DropdownMenuItem>

                              <DropdownMenuItem className="p-0 relative flex cursor-default select-none items-center rounded-sm text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 w-full">
                                <button
                                  className="w-full px-2 py-1.5"
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                  onClick={() => {
                                    setState((prev) => ({ ...prev, isSubmenuOpened: false }));
                                    handleNewClientProject('roman-shade-order');
                                  }}
                                  data-qa="client-add-item-roman-shade"
                                >
                                  <span style={{ whiteSpace: 'nowrap' }}>Roman Shade</span>
                                </button>
                              </DropdownMenuItem>

                              <DropdownMenuItem className="p-0 relative flex cursor-default select-none items-center rounded-sm text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 w-full">
                                <button
                                  className="w-full px-2 py-1.5"
                                  type="button"
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                  onClick={() => props.handleShowBottomSheet(true, state.client)}
                                  data-qa="client-add-item-purchased-goods"
                                >
                                  <span>Purchased Goods</span>
                                  {showNewBadge ? <span className="new_pill">New</span> : null}
                                </button>
                              </DropdownMenuItem>
                              <DropdownMenuItem className="p-0 relative flex cursor-default select-none items-center rounded-sm text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 w-full">
                                <button
                                  className="w-full px-2 py-1.5"
                                  onClick={() => {
                                    setState((prev) => ({ ...prev, isSubmenuOpened: false }));
                                    handleNewClientProject('custom-order');
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                  data-qa="client-add-item-other"
                                >
                                  <span>Other</span>
                                </button>
                              </DropdownMenuItem>

                              {checkGate(QUIPA_ASSISTANT_CREATE_PROJECT_GATE) && (
                                <>
                                  <div
                                    style={{
                                      height: 1,
                                      background: '#e5e7eb',
                                      margin: '6px 0',
                                    }}
                                  />
                                  <DropdownMenuItem className="p-0 relative flex cursor-default select-none items-center rounded-sm text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 w-full">
                                    <button
                                      className="w-full px-2 py-1.5 text-left"
                                      style={{
                                        whiteSpace: 'normal',
                                        height: 'auto',
                                        lineHeight: 1.35,
                                      }}
                                      onClick={() => {
                                        setState((prev) => ({
                                          ...prev,
                                          isSubmenuOpened: false,
                                        }));
                                        openQuipaAssistant({
                                          source: 'client',
                                          clientId: client.id,
                                          clientName: client.displayName,
                                        });
                                      }}
                                      data-qa="client-add-item-assistant"
                                    >
                                      <span>Start New Project with QUIPA Assistant</span>
                                    </button>
                                  </DropdownMenuItem>
                                </>
                              )}
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </div>
                      </div>
                    )}
                    {state.table_type === 'estimating' && state.accountCanSeePricing && (
                      <div>
                        <Button
                          onClick={() => {
                            if (estimateRef?.current?.openBuilder) {
                              estimateRef?.current?.openBuilder('create');
                            }
                          }}
                        >
                          <LucidePlus className="lucide lucide-plus w-4 h-4 mr-2" />
                          <span>New Estimate</span>
                        </Button>
                      </div>
                    )}
                    {state.table_type === 'pos' && state.accountCanSeePricing && (
                      <div>
                        <Button
                          onClick={() => {
                            if (posRef?.current?.handleOpenPoBuilder) {
                              posRef?.current?.handleOpenPoBuilder('create');
                            }
                          }}
                        >
                          <LucidePlus className="lucide lucide-plus w-4 h-4 mr-2" />
                          <span>Create PO</span>
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                {state.table_type === 'items' && (
                  <div className="table_filters w-full">
                    <div
                      className="relative inline-flex w-full max-w-xs shrink-0"
                      data-qa="client-search"
                    >
                      <Input
                        id="client_search_input"
                        ref={searchInputRef}
                        value={state.searchTerm || ''}
                        onChange={handleChangeValueSearchInput}
                        placeholder="Search..."
                        className="pl-9 pr-10 placeholder:font-normal"
                        data-qa="client-search-input"
                      />
                      <div className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2">
                        <Search className="size-4 text-muted-foreground" />
                      </div>
                      {state.searchTerm && (
                        <div className="absolute right-2 top-1/2 -translate-y-1/2">
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            onMouseDown={handleClearSearchKeyword}
                            className="h-6 w-6 cursor-pointer p-0"
                            data-qa="client-search-clear"
                          >
                            <CirclePlus
                              id="client_search_input_clear"
                              stroke="white"
                              fill="#3b87a0"
                              className="size-5 rotate-[45deg]"
                            />
                          </Button>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center gap-2 md:hidden">
                      <div data-qa="client-filters-drawer">
                        <FiltersDrawer {...drawerFilters} />
                      </div>
                      <div data-qa="client-column-visibility-mobile">
                        <ColumnVisibilityMenu {...columnVisibilityMenuProps} />
                      </div>
                    </div>

                    <div className="hidden md:contents">
                      <div data-qa="client-filter-rooms">
                        <Filter
                          shadcn
                          filter_name={'Rooms'}
                          filter_key={'rooms'}
                          filter_values={state.filters.rooms.value}
                          multiple_select={true}
                          dataQaPrefix="client"
                          items={roomsMap}
                          archived={false}
                          show_option_all={false}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                        />
                      </div>

                      <div data-qa="client-filter-items">
                        <Filter
                          shadcn
                          filter_name={'Items'}
                          filter_key={'items'}
                          filter_values={state.filters.items.value}
                          multiple_select={true}
                          dataQaPrefix="client"
                          items={itemsMap}
                          archived={true}
                          archivedCheckbox={state.showArchived}
                          show_option_all={false}
                          archivedProjectsFunction={true}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={onShowArchiveChange}
                        />
                      </div>

                      {canUseRoleAssignments && (
                        <div data-qa="client-filter-assignee">
                          <Filter
                            shadcn
                            filter_name={'Assignee'}
                            filter_key={'assignee'}
                            filter_values={state.filters.assignee.value}
                            multiple_select={true}
                            dataQaPrefix="client"
                            items={assigneeFilterItems}
                            archived={false}
                            show_option_all={false}
                            handleClearAllFilter={handleClearAllFilter}
                            handleChooseFilter={handleChooseFilter}
                          />
                        </div>
                      )}

                      <div data-qa="client-filter-status">
                        <Filter
                          shadcn
                          filter_name={'Status'}
                          filter_key={'status'}
                          filter_values={state.filters.status.value}
                          multiple_select={true}
                          dataQaPrefix="client"
                          items={state.accountStatuses}
                          archived={false}
                          show_option_all={false}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                        />
                      </div>

                      <div className="flex items-center gap-2" data-qa="client-filter-actions">
                        {isFiltersActivate && (
                          <Button
                            variant="resetFilters"
                            type="button"
                            onClick={() => handleResetAllFilters()}
                            data-qa="client-filters-clear"
                          >
                            <LucideX />
                            Clear All
                          </Button>
                        )}
                        <div data-qa="client-column-visibility">
                          <ColumnVisibilityMenu {...columnVisibilityMenuProps} />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* END OF FILTERS */}
              </div>
              {state.generatePdf && (
                <DuplicateSpinner>
                  <FadeLoader
                    style={{
                      position: 'fixed',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(50%,-50%)',
                      zIndex: 100000000,
                      display: !state.generatePdf ? 'none' : 'block',
                    }}
                    color="#3B97B1"
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </DuplicateSpinner>
              )}
              {/* <ClientTabs /> */}
              {state.table_type === 'items' ? (
                <div data-qa="client-items-table">
                  <ProjectOverviewTable
                    className="client-project-overview-table"
                    projectList={visibleProjectList}
                    enableSorting={false}
                    roomList={roomList}
                    checkedProjects={checkedProjects}
                    showArchived={showArchived}
                    showClient={false}
                    columnVisibility={state.columnVisibility}
                    allowDropdownOverflow
                    isParent={false}
                    projectQuery={projectQuery}
                    onNewClientProject={handleNewClientProject}
                    onCheckAllRows={checkAllRows}
                    onCheckRow={checkRow}
                    onCheckRoomRows={checkRoomRows}
                    groupRowsByRoom
                    onItemColumnClick={handleProjectItemClicked}
                    canOpenItems={state.accountCanSeePricing}
                    canManageActions={state.accountCanSeePricing}
                    accountIsAdmin={state.accountIsAdmin}
                    roleAssignmentColumns={visibleRoleAssignmentColumns}
                    assignmentOptionsByRoleId={assignmentOptionsByRoleId}
                    customColumns={visibleCustomColumns}
                    onCustomColumnValueChange={persistProjectCustomColumnValue}
                    onWorkOrderColumnClick={handleProjectWorkOrderNumClicked}
                    handleNotCheckedBatchRow={handleNotCheckedBatchRow}
                    onEdited={updateProjects}
                    updateNotebook={updateNotebook}
                    client={client}
                    clients={props.list}
                    // accountId={props.accountId}
                    onActionSelected={handleProjectAction}
                    onShowArchiveChange={onShowArchiveChange}
                    onOpenModal={onOpenModal}
                    loadProjects={loadProjects}
                    mapSortTableToSortOptions={mapSortTableToSortOptions}
                    editProjectItem={editProjectItem}
                    handleEstimate={handleEstimate}
                    onOpenEstimatingTab={() => handleChooseTableType('estimating')}
                    isConnected={props.isConnected}
                    handleChooseFilter={handleChooseFilter}
                    handleClearAllFilter={handleClearAllFilter}
                    filters={state.filters}
                    isFiltersActivate={isFiltersActivate}
                    handleResetAllFilters={handleResetAllFilters}
                    handleSaveComponents={handleSaveComponents}
                    itemNames={state.items}
                    roomNames={state.rooms}
                    tableStatuses={state.accountStatuses}
                    handleTriggerRefetch={handleTriggerRefetch}
                    handleTriggerProjectRefetch={handleTriggerProjectRefetch}
                    handleChangeNewStatusFilter={handleChangeNewStatusFilter}
                    handleSetNewStatusFilter={handleSetNewStatusFilter}
                    handleSaveNewStatus={handleSaveNewStatus}
                    newStatusFilterValue={state.newStatusFilterValue}
                    newStatusFilter={state.newStatusFilter}
                    newStatusRef={newStatusRef}
                    handleResetNewStatus={handleResetNewStatus}
                    handleProcessEstimate={handleProcessEstimate}
                    handlePrint={handlePrint}
                    isPrintModalOpen={state.isPrintModalOpen}
                    openPrintModal={handlePrintModal}
                    handleOpenSinglePurchasedGoods={props.handleOpenSinglePurchasedGoods}
                    projectRefetch={state.projectRefetch}
                    purchasedGoodsRefetch={props.purchasedGoodsRefetch}
                    accountUser={props.accountUser}
                    canAccessTeamSettings={props.canAccessTeamSettings}
                    handleOpenInvitePanel={handleOpenInvitePanel}
                    roleAssignmentTeamMembers={teamMembers}
                    roleAssignmentAssignees={assigneesWithoutLogin}
                    handleUpdateTeamMember={handleUpdateTeamMember}
                    handleUpdateAssignee={handleUpdateAssignee}
                    backToTop={props.backToTop}
                    pageScrollTo={props.pageScrollTo}
                    onOpenEstimate={handleOpenEstimateFromStatus}
                  />
                </div>
              ) : state.table_type === 'fees' ? (
                <div data-qa="client-fees-table">
                  <FeesTable {...feesProps} />
                </div>
              ) : state.table_type === 'estimating' ? (
                <div data-qa="client-estimating-table">
                  <ClientEstimating
                    ref={estimateRef}
                    clientId={client?.id || props.clientId}
                    accountId={props.accountId}
                    client={client}
                    account={account}
                    accountUser={props.accountUser}
                    singleUser={!props.canAccessTeamSettings}
                    qboConnected={props.isConnected}
                    onChanged={handleEstimateSheetChanged}
                  />
                </div>
              ) : state.table_type === 'pos' ? (
                <POs ref={posRef} {...posProps} />
              ) : (
                <div data-qa="client-ordering-and-receiving-table">
                  <ClientOrderingAndReceiving
                    account={account}
                    accountUser={props.accountUser}
                    canAccessTeamSettings={props.canAccessTeamSettings}
                    history={props.history}
                    handleOpenSinglePurchasedGoods={props.handleOpenSinglePurchasedGoods}
                    backToTop={props.backToTop}
                    pageScrollTo={props.pageScrollTo}
                    clientScopeId={client?.id || props.clientId}
                    hiddenColumnKeys={['clientProject']}
                    showPageHeader={false}
                    handleLinkedPO={handleLinkedPO}
                    canOpenPO={state.accountCanSeePricing}
                  />
                </div>
              )}
              <div data-qa="client-fees-modal">
                <FeesModal {...feesModalProps} />
              </div>

              <div data-qa="client-edit-modal">
                <ClientModal
                  key={client.id}
                  client={client}
                  isModalOpen={state.isEditClientModalOpen}
                  onModalClose={closeEditClientModal}
                  onClientSaved={onClientEdited}
                  resetOnClose
                  setFocusFirstField={(fn) => (setFocusFirstFieldOnClientModalRef.current = fn)}
                  onUpdateModalKey={updateModalKey}
                  addSubClient={state.addSubClient}
                />
              </div>
              <div data-qa="client-estimate-modal">
                <EstimateModal
                  accountId={Number(localStorage.getItem('accountId'))}
                  isModalOpen={state.isEstimateModalOpen}
                  key={'estimate-' + client.id}
                  estimateId={state.qbEstimateId || ''}
                  qbEstimateDocNumber={state.qbEstimateDocNumber || ''}
                  onClose={() => setState({ isEstimateModalOpen: false })}
                />
              </div>
              <EstimateBuilderSheet
                open={estimateSheetState.open}
                initialMode="view"
                estimateId={estimateSheetState.estimateId}
                clientId={client?.id || props.clientId}
                accountId={props.accountId}
                client={client}
                account={account}
                accountUser={props.accountUser}
                qboConnected={props.isConnected}
                existingEstimates={estimateSheetState.estimates}
                onClose={handleCloseEstimateSheet}
                onChanged={handleEstimateSheetChanged}
                onSaved={handleEstimateSheetSaved}
                singleUser={!props.canAccessTeamSettings}
              />
              <div data-qa="client-export-confirmation-modal">
                <ExportConfirmationModal
                  uiActive={state.isExportConfirmationModalOpen}
                  selectedNumber={state.selectedNumber}
                  ordersWithoutWO={state.notReadyOrders}
                  uiOnCancel={handleModalCancel}
                  uiOnContinue={handleModalContinue}
                />
              </div>
              <div data-qa="client-edit-items-modal">
                <EditItemsModal
                  active={state.isEditItemsModalOpen}
                  onRequestClose={editItemModalClose}
                  roomList={roomList}
                  onSave={batchEdit}
                  clients={props.list}
                  handleSearchClient={handleSearchClient}
                  statuses={state.accountStatuses}
                  qboConnected={props.isConnected}
                  estimateNumberDisabled={selectedBatchItemsHaveEstimateConnection}
                />
              </div>
              <div data-qa="client-loading-modal">
                <LoadingModal
                  message="Creating work order..."
                  isModalOpen={state.isLoadingOpen}
                  onModalClose={toggleLoadingModal}
                />
              </div>

              <div data-qa="client-bundle-setup-modal">
                <BundleSetupModal
                  uiActive={state.isBundleSetupModalOpen}
                  uiOnRequestClose={handleCloseBundleSetupModal}
                  uiCloseOnOutsideClick={true}
                  uiCloseOnEsc={true}
                  onRetry={handleRetryBundleExport}
                  onExportWithoutBundling={handleExportWithoutBundling}
                  missingItems={state.bundleSetupMissingItems}
                />
              </div>

              <div data-qa="client-quickbooks-error-modal">
                <QuickBooksErrorModal {...quickBooksErrorModalProps}>
                  <div>
                    <p>
                      Your client or project name includes a “:”, which QuickBooks doesn’t support.
                      Remove the colon and export again.
                    </p>
                  </div>
                </QuickBooksErrorModal>
              </div>

              {state.duplicateLoading && (
                <DuplicateSpinner data-qa="client-duplicate-loader">
                  <FadeLoader
                    style={{
                      position: 'fixed',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(50%,-50%)',
                      zIndex: 9999,
                      display: !state.duplicateLoading ? 'none' : 'block',
                    }}
                    color="#3B97B1"
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </DuplicateSpinner>
              )}

              {state.exportingEstimateLoading && (
                <DuplicateSpinner
                  style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
                  data-qa="client-export-loader"
                >
                  <FadeLoader
                    style={{
                      position: 'fixed',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      zIndex: 9999,
                    }}
                    color="#3B97B1"
                    aria-label="Loading Spinner"
                    data-testid="export-loader"
                  />
                </DuplicateSpinner>
              )}

              {canManageTeamMembers ? (
                <WideSheet
                  open={isInvitePanelOpen}
                  onCancel={handleCloseInvitePanel}
                  onSave={handleSubmitInvitePanel}
                  title="Add"
                  subTitle={
                    invitePanelMode === 'team_member'
                      ? 'Invite a team member with login access'
                      : 'Add an assignee without login'
                  }
                  saveLabel={
                    invitePanelMode === 'team_member'
                      ? isInvitingMember
                        ? 'Sending...'
                        : 'Send Invitation'
                      : 'Add Assignee'
                  }
                  cancelLabel="Cancel"
                  saveDisabled={!canSubmitInvitePanel}
                  overlayDataQa="team-settings-invite-panel-overlay-close"
                  overlayStyle={{
                    backgroundColor: 'rgba(0, 0, 0, 0.78)',
                  }}
                  closeButtonDataQa="team-settings-invite-panel-close-button"
                  cancelButtonDataQa="team-settings-invite-panel-cancel"
                  saveButtonDataQa="team-settings-invite-panel-submit"
                >
                  <div>
                    <div className="grid grid-cols-2 overflow-hidden rounded-[8px] border border-[#D8E0E8]">
                      <button
                        type="button"
                        className={`border-0 py-3 text-[14px] font-semibold ${
                          invitePanelMode === 'team_member'
                            ? 'bg-[#3B97B1] text-white'
                            : 'bg-white text-[#64748B]'
                        }`}
                        onClick={() => handleSwitchInviteMode('team_member')}
                        data-qa="team-settings-invite-panel-mode-team-member"
                      >
                        Add Team Member
                      </button>
                      <button
                        type="button"
                        className={`border-0 py-3 text-[14px] font-semibold ${
                          invitePanelMode === 'assignee'
                            ? 'bg-[#3B97B1] text-white'
                            : 'bg-white text-[#64748B]'
                        }`}
                        onClick={() => handleSwitchInviteMode('assignee')}
                        data-qa="team-settings-invite-panel-mode-assignee"
                      >
                        Add Assignee
                      </button>
                    </div>

                    <div className="mt-5 rounded-[8px] border border-[#D8E0E8] bg-[#f1f5f980] px-4 py-4">
                      <div className="flex items-center gap-3">
                        {invitePanelMode === 'team_member' ? (
                          <UserCheckIcon className="h-5 w-5 text-[#64748B]" />
                        ) : (
                          <ClipboardList className="h-5 w-5 text-[#64748B]" />
                        )}
                        <h3 className="m-0 text-[14px] font-semibold text-[#111827]">
                          {invitePanelMode === 'team_member'
                            ? 'Team Member'
                            : 'Assignees without login'}
                        </h3>
                      </div>
                      <ul className="m-0 mt-3 list-outside list-disc pl-14 text-[14px] text-[#60778F]">
                        {invitePanelMode === 'team_member' ? (
                          <>
                            <li>Creates a Quipa user with login access</li>
                            <li>Can log in and view assigned work</li>
                            <li>Can collaborate with the team</li>
                            <li>Receives notifications and @mentions</li>
                            <li>Uses a paid seat</li>
                          </>
                        ) : (
                          <>
                            <li>People you assign work to who do not have Quipa access</li>
                            <li>Appear in assignee lists</li>
                            <li>Do not receive notifications or @mentions</li>
                          </>
                        )}
                      </ul>
                    </div>

                    {invitePanelMode === 'team_member' ? (
                      <>
                        <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                          <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                            Contact Information
                          </h3>
                          <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                            Email
                          </label>
                          <div className="relative mt-2">
                            <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                            <Input
                              type="email"
                              placeholder="teammate@company.com"
                              value={memberEmail}
                              onChange={(e) => setMemberEmail(e.target.value)}
                              className="h-11 pl-9"
                              data-qa="team-settings-invite-member-email-input"
                            />
                          </div>
                        </div>

                        <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                          <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Roles</h3>
                          <p className="mb-0 mt-4 text-[14px] text-[#60778F]">
                            Assign work roles to describe what type of work this person does.
                          </p>
                          <div className="mt-4 rounded-[8px] border border-[#D8E0E8] bg-white px-3 py-3">
                            {roles.length === 0 ? (
                              <p className="m-0 text-[14px] text-[#64748B]">
                                No roles created yet. Add roles in the Roles tab first.
                              </p>
                            ) : (
                              <div className="flex flex-col gap-3">
                                {roles.map((role) => (
                                  <label
                                    key={`member-role-${role.id}`}
                                    className="flex items-center gap-3 text-[14px] font-semibold text-[#111827]"
                                    data-qa={`team-settings-invite-member-role-${role.id}-label`}
                                  >
                                    <Checkbox
                                      checked={memberSelectedRoleIds.includes(role.id)}
                                      onCheckedChange={(checked) =>
                                        toggleMemberRole(role.id, checked === true)
                                      }
                                      data-qa={`team-settings-invite-member-role-${role.id}-checkbox`}
                                    />
                                    <span>{role.name}</span>
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                          <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                            Permissions
                          </h3>
                          <div className="mt-4 flex flex-col gap-3">
                            <div className="relative inline-flex w-fit items-center gap-3 text-[14px] text-[#111827]">
                              <Checkbox
                                checked={memberPricingAccess}
                                onCheckedChange={(checked) =>
                                  setMemberPricingAccess(checked === true)
                                }
                                data-qa="team-settings-invite-member-pricing-access-checkbox"
                              />
                              <span>Pricing access</span>
                              <PermissionHelpTooltip
                                tooltipKey="pricing"
                                enabled={isInvitePanelOpen}
                                open={openPermissionTooltip === 'pricing'}
                                onOpenChange={(nextOpen) =>
                                  setOpenPermissionTooltip(nextOpen ? 'pricing' : null)
                                }
                                ariaLabel="Show pricing access help"
                                content="View and edit item details, construction settings, and My Shop entries."
                                width={290}
                                triggerDataQa="team-settings-invite-member-pricing-access-help"
                                contentDataQa="team-settings-invite-member-pricing-access-help-content"
                              />
                            </div>
                            <div className="relative inline-flex w-fit items-center gap-3 text-[14px] text-[#111827]">
                              <Checkbox
                                checked={memberAdminAccess}
                                onCheckedChange={(checked) =>
                                  setMemberAdminAccess(checked === true)
                                }
                                data-qa="team-settings-invite-member-admin-access-checkbox"
                              />
                              <span>Administration access</span>
                              <PermissionHelpTooltip
                                tooltipKey="admin"
                                enabled={isInvitePanelOpen}
                                open={openPermissionTooltip === 'admin'}
                                onOpenChange={(nextOpen) =>
                                  setOpenPermissionTooltip(nextOpen ? 'admin' : null)
                                }
                                ariaLabel="Show administration access help"
                                content="Manage account settings, users and roles, integrations, and workspace configuration."
                                width={320}
                                triggerDataQa="team-settings-invite-member-admin-access-help"
                                contentDataQa="team-settings-invite-member-admin-access-help-content"
                              />
                            </div>
                          </div>
                        </div>

                        {isSeatLimitReached ? (
                          <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                            <div className="flex items-center gap-2">
                              <TriangleAlert className="h-5 w-5 text-[#F59E0B]" />
                              <h3 className="m-0 text-[16px] font-semibold text-[#C66A00]">
                                Seat Limit Reached
                              </h3>
                            </div>
                            <p className="m-0 mt-4 text-[14px] text-[#60778F]">
                              You have reached the seat limit for your account.{' '}
                              <button
                                type="button"
                                className="inline cursor-pointer border-0 bg-transparent p-0 text-[#2F8FB0] hover:text-[#267990]"
                                onClick={() => handleOpenSeatsModal(true)}
                                data-qa="team_settings_add_seats_button_link"
                              >
                                Add more seats
                              </button>{' '}
                              or{' '}
                              <button
                                type="button"
                                className="inline cursor-pointer border-0 bg-transparent p-0 text-[#2F8FB0] hover:text-[#267990]"
                                onClick={() => {
                                  void handleChangePlan();
                                }}
                                data-qa="team-settings-invite-seat-limit-upgrade-plan"
                              >
                                Upgrade your plan
                              </button>
                            </p>
                            <div className="mt-4 flex flex-wrap items-center gap-3">
                              <Dialog
                                open={openSeatsModal}
                                onOpenChange={(val) => handleOpenSeatsModal(val)}
                              >
                                <DialogTrigger asChild>
                                  <Button
                                    type="button"
                                    variant={'default'}
                                    className="min-h-[36px]"
                                    // onClick={() => handleOpenSeatsModal(true)}
                                    // disabled={false}
                                    data-qa="team_settings_add_seats_button"
                                  >
                                    Add Seats
                                  </Button>
                                </DialogTrigger>
                                <DialogContent className="max-w-[700px]">
                                  <DialogHeader>
                                    <DialogTitle className="m-0 text-[24px]">
                                      Buy Extra Seats
                                    </DialogTitle>
                                  </DialogHeader>

                                  <div className="flex flex-col gap-4">
                                    <div className="md:text-start text-center md:ml-4">
                                      <RadioGroup
                                        disabled={seatLoading}
                                        className="flex items-center gap-1 rounded-md w-max"
                                        value={seatState.interval}
                                        onValueChange={(val) => handleChangeInterval(val)}
                                      >
                                        <div className="">
                                          <RadioGroupItem
                                            value={'month'}
                                            id="seat_monthly"
                                            className="hidden"
                                          />
                                          <Label
                                            data-loading={seatLoading}
                                            data-checked={seatState.interval === 'month'}
                                            htmlFor="seat_monthly"
                                            className="transition duration-300 cursor-pointer px-[12px] py-[8px] rounded-md data-[checked=true]:shadow-[0_0_0_2px_rgba(59,151,177,1)] border border-input data-[checked=false]:bg-white data-[loading=true]:opacity-50"
                                          >
                                            Monthly
                                          </Label>
                                        </div>
                                        <div className="">
                                          <RadioGroupItem
                                            value={'year'}
                                            id="seat_yearly"
                                            className="hidden"
                                          />
                                          <Label
                                            data-loading={seatLoading}
                                            data-checked={seatState.interval === 'year'}
                                            htmlFor="seat_yearly"
                                            className="transition duration-300 cursor-pointer px-[12px] py-[8px] rounded-md data-[checked=true]:shadow-[0_0_0_2px_rgba(59,151,177,1)] border border-input data-[checked=false]:bg-white data-[loading=true]:opacity-50"
                                          >
                                            Yearly
                                          </Label>
                                        </div>
                                      </RadioGroup>
                                    </div>

                                    <div className="p-[24px] rounded-[12px] border border-2 border-primary_dark">
                                      <div className="flex md:flex-row flex-col justify-between gap-2">
                                        <div>
                                          <div className="mb-4 flex items-center gap-2">
                                            <div>
                                              <Input
                                                disabled={seatLoading}
                                                onChange={(e) => handleChangeSeatQty(e)}
                                                className="px-1 text-center max-w-[60px] min-h-[10px] max-h-max"
                                                value={seatState.quantity}
                                                autoFocus
                                              />
                                            </div>
                                            <span className="text-[18px] font-medium">
                                              Extra Seat{Number(seatState.quantity) > 1 ? 's' : ''}
                                            </span>
                                          </div>

                                          <div>
                                            <span>
                                              $
                                              {(
                                                (+seatState.cost || 0) * (+seatState.quantity || 0)
                                              ).toFixed(2)}{' '}
                                              per {seatState.interval}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="flex items-center">
                                          <div className="flex items-center gap-2 px-[16px] py-[8px] border border-input rounded-md">
                                            <CircleCheck className="w-[16px] h-[16px] text-primary" />
                                            <span>Selected</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <DialogFooter>
                                    <DialogClose>
                                      <Button type="button" variant={'outline'}>
                                        Close
                                      </Button>
                                    </DialogClose>
                                    <Button
                                      disabled={seatLoading || !seatState.quantity}
                                      onClick={() => handleBuyMoreSeats()}
                                      type="button"
                                    >
                                      Buy
                                    </Button>
                                  </DialogFooter>
                                </DialogContent>
                              </Dialog>

                              <Button
                                variant={'outline'}
                                type="button"
                                className="font-medium min-h-[36px]"
                                onClick={() => {
                                  void handleRemoveInactiveMembers();
                                }}
                                disabled={isRemovingInactiveMembers || isInvitationActionDisabled()}
                                data-qa="team-settings-invite-seat-limit-remove-inactive-members"
                              >
                                {isRemovingInactiveMembers
                                  ? 'Removing...'
                                  : 'Remove inactive members'}
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                            <div className="flex items-center gap-3">
                              <CreditCard className="h-5 w-5 text-[#64748B]" />
                              <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                                Seat Usage
                              </h3>
                            </div>
                            <p className="mb-0 mt-4 text-[14px] text-[#111827]">
                              Current: {usedSlots} of {availableSlots} seats used
                            </p>
                            <div className="mt-3 h-[8px] rounded-full bg-[#D7E2E9]">
                              <div
                                className="h-full rounded-full bg-[#3B97B1]"
                                style={{ width: `${seatUsagePercent}%` }}
                              />
                            </div>
                            <p className="m-0 mt-4 text-[14px] text-[#60778F]">
                              Sending this invitation will use 1 seat. You will have{' '}
                              {remainingSeatsAfterInvite} seats remaining.
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                          <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                            Assignee Information
                          </h3>
                          <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                            Name *
                          </label>
                          <div className="relative mt-2">
                            <UserRound className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                            <Input
                              type="text"
                              placeholder="John Smith"
                              value={assigneeName}
                              onChange={(e) => handleAssigneeNameChange(e.target.value)}
                              className="h-11 pl-9"
                              data-qa="team-settings-invite-assignee-name-input"
                            />
                          </div>

                          <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                            Label * <span className="font-normal text-[#60778F]">(1-4 chars)</span>
                          </label>
                          <div className="relative mt-2">
                            <AtSign className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                            <Input
                              type="text"
                              placeholder="JS"
                              value={assigneeLabel}
                              onChange={(e) => handleAssigneeLabelChange(e.target.value)}
                              className="h-11 pl-9"
                              data-qa="team-settings-invite-assignee-label-input"
                            />
                          </div>
                          <p className="m-0 mt-2 text-[14px] text-[#60778F]">Used for @mentions</p>
                        </div>

                        <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                          <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Roles *</h3>
                          <p className="mb-0 mt-4 text-[14px] text-[#60778F]">
                            Select at least one role to describe what type of work this person does.
                          </p>
                          <div className="mt-4 rounded-[8px] border border-[#D8E0E8] bg-white px-3 py-3">
                            {roles.length === 0 ? (
                              <p className="m-0 text-[14px] text-[#64748B]">
                                No roles created yet. Add roles in the Roles tab first.
                              </p>
                            ) : (
                              <div className="flex flex-col gap-3">
                                {roles.map((role) => (
                                  <label
                                    key={`assignee-role-${role.id}`}
                                    className="flex items-center gap-3 text-[14px] font-semibold text-[#111827]"
                                    data-qa={`team-settings-invite-assignee-role-${role.id}-label`}
                                  >
                                    <Checkbox
                                      checked={assigneeSelectedRoleIds.includes(role.id)}
                                      onCheckedChange={(checked) =>
                                        toggleAssigneeRole(role.id, checked === true)
                                      }
                                      data-qa={`team-settings-invite-assignee-role-${role.id}-checkbox`}
                                    />
                                    <span>{role.name}</span>
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </WideSheet>
              ) : null}
            </PopoverScrollContext.Provider>
          </ClientInfo>
        </CSSTransition>
      </CSSTransitionBox>
    );
  };
  const updateModalKey = async (): Promise<void> => {
    setState((prevState) => ({ modalKey: prevState.modalKey + 1 }));
    loadProjects();
  };
  const checkAllRows = (checked: boolean) => {
    setState({
      checkedProjects: checked ? state.projectList.map((p) => p.itemId) : [],
    });
  };
  const createSubClient = (): void => {
    setState((prev) => {
      return {
        ...prev,
        addSubClient: !state.addSubClient,
      };
    });
  };

  const handleSearchClient: SearchSelectProps['onSearch'] = async (search: string) => {
    const res = await searchClients({
      text: search,
      accountId: props.accountId,
    });
    if (res.error) {
      return [];
    }
    return res.map((r: any) => ({
      id: r.id,
      displayName: (r.parent ? r.parent.displayName + ' | ' : '') + r.displayName,
    }));
  };

  const checkRow = (id: number, checked: boolean) => {
    if (checked) {
      if (state.checkedProjects.includes(id)) {
        return;
      }
      setState({
        checkedProjects: [...state.checkedProjects, id],
      });
    } else {
      setState({
        checkedProjects: state.checkedProjects.filter((cid) => cid !== id),
      });
    }
  };

  const checkRoomRows = (roomProjectIds: any, checked: boolean) => {
    if (checked) {
      if (state.checkedProjects.includes(roomProjectIds)) {
        return;
      }
      setState({
        checkedProjects: [...state.checkedProjects, ...roomProjectIds],
      });
    } else {
      setState({
        checkedProjects: state.checkedProjects.filter((cid) => !roomProjectIds.includes(cid)),
      });
    }
  };

  const batchEdit: EditItemsModalProps['onSave'] = async (newValues) => {
    if (!state.checkedProjects.length) {
      return;
    }
    // close modal early. Ideally modal should await for onSave callback and display spinner
    setState({ isEditClientModalOpen: false });
    const estimateBatchEditFields = new Set([
      'estimateStatus',
      'estimateNumber',
      'qbEstimateNumber',
      'estimateDate',
      'estimateDateSent',
      'changedFields',
    ]);
    const changedFields = newValues.changedFields || {};
    const nonEmptyValues = Object.entries(newValues).reduce((all, [key, val]) => {
      if (val && !estimateBatchEditFields.has(key)) {
        all[key] = val;
      }
      return all;
      // tslint:disable-next-line:no-object-literal-type-assertion
    }, {} as Partial<EditValues>);
    if (newValues.estimateStatus) {
      nonEmptyValues.estimateStatus = newValues.estimateStatus;
    }
    if (newValues.estimateNumber || changedFields.estimateNumber) {
      nonEmptyValues.estimateNumber = newValues.estimateNumber || null;
    }
    if (newValues.qbEstimateNumber || changedFields.qbEstimateNumber) {
      nonEmptyValues.qbEstimateNumber = newValues.qbEstimateNumber || null;
    }
    if (
      changedFields.estimateDateSent ||
      (newValues.estimateDateSent !== null && newValues.estimateDateSent !== undefined)
    ) {
      nonEmptyValues.estimateDateSent = newValues.estimateDateSent || null;
      nonEmptyValues.estimateDate = newValues.estimateDateSent || null;
    }

    const filteredNewProjects = state.projectList.filter((i) => !i.archived);

    let newProjects = [...filteredNewProjects];
    for (const id of state.checkedProjects) {
      const projIdx = newProjects.findIndex((proj) => proj.itemId === id);
      if (projIdx === -1) {
        continue;
      }
      const proj = newProjects[projIdx];
      if (!proj) {
        continue;
      }
      const newProj: ClientDashboardModule.ClientProject = {
        ...proj,
        ...nonEmptyValues,
      };
      if (!newValues.clientId) {
        newProjects[projIdx] = newProj;
      } else {
        const filteredNewProjects = newProjects.filter((c) => c.itemId !== id);
        newProjects = filteredNewProjects;
      }
      await editProjectItem(newProj);
    }

    setState({
      projectList: newProjects,
      checkedProjects: [],
      isEditItemsModalOpen: false,
    });
    loadProjects();
  };

  const editItemModalClose = () => {
    setState({ isEditItemsModalOpen: false });
  };

  const toggleClientDetails = () => {
    setState({ detailsDisplayed: !state.detailsDisplayed });
  };

  const closeEditClientModal = () => {
    setState({
      addSubClient: false,
      isEditClientModalOpen: false,
    });
  };

  const openClientModal = async () => {
    const clientId = Number(state.client?.id || props.clientId || 0);
    if (clientId > 0) {
      try {
        const latestClient = await getClientApi({
          clientId,
          accountId: props.accountId,
        });
        if (!latestClient?.error && latestClient?.id) {
          setState({ client: latestClient });
        }
      } catch (error) {
        console.error('Failed to refresh client before opening edit modal:', error);
      }
    }

    setState(
      {
        isEditClientModalOpen: true,
      },
      () => {
        if (setFocusFirstFieldOnClientModalRef.current) {
          setFocusFirstFieldOnClientModalRef.current();
        }
      }
    );
  };

  const onClientEdited = (client: ClientModule.Client) => {
    setState({
      client,
    });
    processItems('edit', client.active);
    props.onClientChanged(client);
  };

  const handleNewClientProject = async (type: string) => {
    const { client } = state;
    const can_create_order = await userCanCreateNewOrder(props.accountId);
    if (!can_create_order && state.remainingItemOrder === 0 && type !== 'custom-order') {
      props.handleOpenSubscriptionPlanModal();
      return;
    }
    if (client) {
      props.gotoDraperyOrder(client.id, 0, client.displayName, 'setup', type);
    }
  };

  const handleProjectItemClicked = (
    id?: number | undefined,
    itemId?: number,
    item?: string,
    target?: 'summary',
    customOrderType?: string | null
  ) => {
    if (!state.accountCanSeePricing) {
      return;
    }
    if (id && itemId) {
      props.gotoDraperyOrder(id, itemId, item, 'summary', customOrderType);
    }
  };

  const handlePrintModal = (value: boolean) => {
    setState({ isPrintModalOpen: value });
  };

  const handlePrint = async () => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    const storeId = `${props.accountId}_pdfs`;
    setState({ generatePdf: true });
    const arrProjects = [...state.projectList];
    const projects = arrProjects.filter((p: ClientDashboardModule.ClientProject) => {
      const projectId = Number(p.itemId ?? p.id);
      return (
        Number.isFinite(projectId) &&
        state.checkedProjects.includes(projectId) &&
        !p.workOrderPdfLink &&
        p.workOrderId
      );
    });

    if (projects.length > 0) {
      for (const project of projects) {
        if (project.id) {
          const res = await getWorkOrderPDFContent(project.id);
          const resDraperyOrder = await getAllInfo(project.id);
          const workOrder: WorkOrderModule.WorkOrder = resDraperyOrder.workOrder;
          let buffer;
          let pdfLink;
          let dueDate = res.dueDate;
          let dueDateForLambda = dueDate ? moment(dueDate).local().format('MM/DD/YYYY') : '';

          const needNewPDF = !moment
            .utc(workOrder.dueDatePdf || undefined)
            .startOf('day')
            .isSame(moment.utc(res.dueDate || undefined).startOf('day'));
          const responseForLambda = { ...res, dueDate: dueDateForLambda, needNewPDF: needNewPDF };

          console.log(workOrder.dueDatePdf, 'workOrder.dueDatePdf');
          console.log(res.dueDate, 'res.dueDate');
          console.log(dueDateForLambda, 'dueDateForLambda');
          console.log(workOrder.dueDatePdf, 'workOrder.dueDatePdf');
          console.log(workOrder, 'workOrder');
          console.log(res, 'res');

          console.log(needNewPDF, 'needNewPDF');
          console.log(responseForLambda, responseForLambda);

          if (!workOrder.pdfLink || needNewPDF) {
            const lambdaResponse = await callLambda(
              responseForLambda,
              props.accountId,
              '',
              workOrder
            );
            console.log('entered if block', lambdaResponse);

            const { pdfData } = lambdaResponse;
            buffer = pdfData ? Buffer.from(pdfData, 'base64') : undefined;
            pdfLink = getPdfFileNameFromLambdaResponse(lambdaResponse);
            const index = arrProjects.findIndex((item) => item.id === project.id);
            arrProjects[index].workOrderPdfLink = pdfLink;
            project.workOrderPdfLink = pdfLink;

            // buffer = Buffer.from(pdfData, 'base64');
            await editWorkOrder({ ...workOrder, pdfLink, dueDatePdf: dueDateForLambda });
          }
          if (buffer && pdfLink) {
            console.log('entered if block 2');

            await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
          }

          // if (workOrder.pdfLink) {
          //   console.log('entered if block 3');

          //   const response = await retrieveFile(storeId, workOrder.pdfLink, Config.fileStoreUrl);
          //   buffer = Buffer.from(response, 'base64');
          // }
          if (!workOrder.pdfLink) {
            console.log('entered if block 5');
            await editWorkOrder({ ...workOrder, pdfLink, pdfGeneratedAt: new Date() });
          }
        }

        // let lambdaResponse = await callLambda(
        //   responseForLambda,
        //   accountId,
        //   Config.fileStoreUrl,
        //   workOrder
        // );
      }
    }
    setState(
      (state) => ({ ...state, projectList: arrProjects }),
      async () => {
        try {
          const workOrderPdfLinks = state.projectList
            .filter((p) => {
              const projectId = Number(p.itemId ?? p.id);
              return (
                Number.isFinite(projectId) &&
                state.checkedProjects.includes(projectId) &&
                p.hasOwnProperty('workOrderId')
              );
            })
            .map((item) => item.workOrderPdfLink);
          const res = await mergePdfFiles(workOrderPdfLinks, storeId);
          const url = await getMergedPdfPrintUrl(res);

          iframe.src = url;
          document.body.appendChild(iframe);
          const handle = () => {
            try {
              if (iframe.contentWindow) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              }
            } finally {
              setState((state) => ({ ...state, isPrintModalOpen: false, generatePdf: false }));
            }
          };
          handle();
        } catch (error) {
          showErrorToast(
            isMergePdfNoneFoundError(error)
              ? 'None of the selected PDFs were found. Open the order and regenerate PDF, then try again.'
              : 'Unable to print selected work orders. Please try again.'
          );
          setState((state) => ({ ...state, isPrintModalOpen: false, generatePdf: false }));
        }
      }
    );
  };

  const handleProjectWorkOrderNumClicked = async (id: number) => {
    const { client, workOrderPdfStatus: draperyPdf } = state;
    const accountId = props.accountId;
    if (client && draperyPdf === 'none') {
      const res = await getWorkOrderPDFContent(id);
      if (res.error) {
        return;
      }
      setState(
        {
          isLoadingOpen: true,
          workOrderPdfStatus: 'downloading',
          workOrderPdfContent: res,
        },
        async () => {
          const resDraperyOrder = await getAllInfo(id);
          const workOrder: WorkOrderModule.WorkOrder = resDraperyOrder.workOrder;
          const draperyOrderDesign = resDraperyOrder?.draperyOrderDesign;
          const storeId = `${accountId}_pdfs`;
          let pdfLink;
          let buffer;
          let dueDate = res.dueDate;
          let dueDateForLambda = dueDate ? moment(dueDate).local().format('MM/DD/YYYY') : '';

          const needNewPDF = !moment
            .utc(workOrder.dueDatePdf || undefined)
            .startOf('day')
            .isSame(moment.utc(res.dueDate || undefined).startOf('day'));
          const responseForLambda = { ...res, dueDate: dueDateForLambda, needNewPDF: needNewPDF };

          console.log(workOrder.dueDatePdf, 'workOrder.dueDatePdf');
          console.log(res.dueDate, 'res.dueDate');
          console.log(dueDateForLambda, 'dueDateForLambda');
          console.log(workOrder.dueDatePdf, 'workOrder.dueDatePdf');
          console.log(workOrder, 'workOrder');
          console.log(res, 'res');

          console.log(needNewPDF, 'needNewPDF');
          console.log(responseForLambda, responseForLambda);
          const openBuffer = (pdfBuffer: Uint8Array) => {
            const normalizedBuffer = new Uint8Array(pdfBuffer).slice().buffer;
            const blob = new Blob([normalizedBuffer], {
              type: 'application/pdf',
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          };

          const regeneratePdf = async () => {
            let nextDrawingUrl: string | null = null;
            if (draperyOrderDesign?.id) {
              try {
                nextDrawingUrl = await regenerateWorkOrderDrawing({
                  accountId,
                  design: draperyOrderDesign,
                  orderType: resDraperyOrder?.orderType,
                });
              } catch (error) {
                console.error('Failed to regenerate work order drawing before PDF generation', error);
              }
            }

            const lambdaResponse = await callLambda(
              {
                ...responseForLambda,
                ...(nextDrawingUrl ? { draperyImage: nextDrawingUrl } : {}),
                needNewPDF: true,
              },
              accountId,
              '',
              workOrder
            );
            console.log('entered if block', lambdaResponse);

            const { pdfData } = lambdaResponse;
            pdfLink = getPdfFileNameFromLambdaResponse(lambdaResponse);
            buffer = pdfData ? Buffer.from(pdfData, 'base64') : undefined;
            await editWorkOrder({
              ...workOrder,
              pdfLink,
              dueDatePdf: dueDateForLambda,
              pdfGeneratedAt: new Date(),
            });
          };

          if (!workOrder.pdfLink || needNewPDF) {
            await regeneratePdf();
          }

          if (buffer && pdfLink) {
            console.log('entered if block 2');

            await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
          }

          if (buffer) {
            console.log('entered if block 4');
            openBuffer(buffer);
          } else {
            const fileName = pdfLink ? pdfLink : workOrder.pdfLink;
            if (fileName) {
              try {
                console.log('entered if block 3');
                await openStoredPdf(storeId, fileName, Config.fileStoreUrl);
              } catch (error) {
                if (!isStoredFileMissingError(error)) {
                  throw error;
                }

                await regeneratePdf();

                if (buffer && pdfLink) {
                  await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
                  openBuffer(buffer);
                } else if (pdfLink) {
                  await openStoredPdf(storeId, pdfLink, Config.fileStoreUrl);
                }
              }
            }
          }
          handleDraperyPdfFinished(true);
        }
      );
    }
  };

  const handleDraperyPdfFinished = (success: boolean) => {
    const { dispatch } = props;
    if (success) {
      if (!state.isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Work order created successfully!',
          type: 'info',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      setState({
        workOrderPdfStatus: 'none',
        isLoadingOpen: false,
      });
    } else {
      if (!state.isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Failed to create work order !',
          type: 'error',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      setState({
        workOrderPdfStatus: 'error',
        isLoadingOpen: false,
      });
    }
  };

  const toggleLoadingModal = () => {
    setState({ isLoadingOpen: !state.isLoadingOpen });
  };

  const updateProjects: ProjectOverviewTableProps['onEdited'] = (projects) => {
    const normalizeId = (value: any): number | null => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const newProjects = [...state.projectList];
    for (const proj of projects) {
      const incomingItemId = normalizeId(proj?.itemId);
      const incomingId = normalizeId(proj?.id);
      const projIdx = state.projectList.findIndex((p) => {
        const currentItemId = normalizeId(p?.itemId);
        const currentId = normalizeId(p?.id);
        if (incomingItemId !== null && currentItemId === incomingItemId) return true;
        if (incomingId !== null && currentId === incomingId) return true;
        return false;
      });
      if (projIdx === -1) {
        continue;
      }
      newProjects[projIdx] = { ...newProjects[projIdx], ...proj };
      // actually API should support batch editing multiple project at once and we need to await here to handle any errors
      editProjectItem(newProjects[projIdx]);
    }
    setState({ projectList: newProjects });
  };

  const persistProjectCustomColumnValue = async (
    project: any,
    columnId: CustomColumnId,
    value: string
  ) => {
    if (!project || !columnId) {
      return false;
    }

    const nextProject = {
      ...project,
      customColumnsValues: writeCustomColumnValue(project?.customColumnsValues, columnId, value),
    };

    updateProjects([nextProject]);
    return true;
  };

  const editProjectItem = async (project: ClientDashboardModule.ClientProject): Promise<void> => {
    const res: any = await editClientProject(project);

    trackView(MixpanelEvents.UPDATE_ORDER, {
      orderId: project.itemId,
      orderType: project.orderType,
      element: 'three_dot_menu',
    });

    if (res.error) {
      trackView(MixpanelEvents.UPDATE_ORDER, {
        orderId: project.itemId,
        orderType: project.orderType,
        be_error_text: res && res.message ? res.message : res,
        element: 'three_dot_menu',
      });
      return;
    }
  };

  const processItems = async (
    action: 'archive' | 'unarchive' | 'duplicate' | 'edit' | 'delete',
    isActive?: boolean,
    type?: string,
    projectIds?: number[]
    // canCreateOrder?: boolean,
  ) => {
    if (
      !state.accountCanSeePricing &&
      !['archive', 'unarchive', 'delete', 'edit'].includes(action)
    ) {
      return;
    }
    const { accountId, clientId } = props;
    const { projectList, checkedProjects, client } = state;
    const effectiveIds =
      projectIds && projectIds.length
        ? // ? Array.from(new Set([...checkedProjects, ...projectIds]))
          Array.from(new Set(projectIds))
        : checkedProjects;
    const projectsToProcess = projectList.filter((project) =>
      effectiveIds.includes(project.itemId)
    );

    const clientDb = await getClientApi({ clientId });

    // const getProjectsRes = await getClientProjects({
    //     accountId,
    //     clientId,
    //     includeArchived: true,
    //     sort: { field: '', direction: "ASC" },
    // });

    // console.log(getProjectsRes, projectList);

    if (
      projectList.length > 0 &&
      action === 'edit' &&
      isActive === true &&
      clientDb.active !== state.initialClientState
    ) {
      for (const project of projectList) {
        const res = await archiveClientProjectItem({
          accountId,
          draperyOrderId: project.itemId,
          archived: false,
        });

        if (res.error) {
          return;
        }
      }
      loadProjects();
    } else if (
      projectList.length > 0 &&
      action === 'edit' &&
      isActive === false &&
      clientDb.active !== state.initialClientState
    ) {
      for (const project of projectList) {
        const res = await archiveClientProjectItem({
          accountId,
          draperyOrderId: project.itemId,
          archived: action === 'edit',
        });

        if (res.error) {
          return;
        }
      }
      loadProjects();
    } else if (projectList.length === 0) {
      const { clientId } = props;
      const sort = state.sortValue;
      const getProjectsRes = await getClientProjects({
        accountId: props.accountId,
        clientId,
        includeArchived: true,
        sort,
      });

      if (Array.isArray(getProjectsRes.payload.result)) {
        for (const project of getProjectsRes.payload.result) {
          const res = await archiveClientProjectItem({
            accountId,
            draperyOrderId: project.itemId,
            archived: isActive === false ? true : false,
          });
          loadProjects();

          if (res.error) {
            return;
          }
        }
      }
    }

    if (!projectsToProcess.length) {
      return;
    }
    let remainingItemOrder = state.remainingItemOrder;
    for (const project of projectsToProcess) {
      if (
        (action === 'archive' && !project.archived) ||
        (action === 'unarchive' && project.archived)
      ) {
        const res = await archiveClientProjectItem({
          accountId,
          draperyOrderId: project.itemId,
          archived: action === 'archive',
        });
        if (res.error) {
          return;
        }
      } else if (action === 'duplicate') {
        const canCreateOrder = await userCanCreateNewOrder(props.accountId);
        const res: any = await draperyOrderCopy({
          accountId,
          draperyOrderId: project.itemId,
          isFromExtraOrderCredit: !canCreateOrder && remainingItemOrder > 0 ? true : false,
        });
        if (!canCreateOrder && project.orderType !== 'custom-order') {
          await updateAccount({ accountId, remainingItemOrder: remainingItemOrder - 1 });
          remainingItemOrder--;
        }
        let orderType;

        if (project && project.orderType) {
          const type = project.orderType;

          if (type === 'custom-order') {
            orderType = 'other';
          } else if (type === 'roman-shade') {
            orderType = 'roman_shade';
          } else if (type === 'drapery-order') {
            orderType = 'drapery';
          } else {
            orderType = type;
          }
        } else {
          orderType = 'unknown';
        }

        let clientName = '';
        if (project && project.client && project.client.displayName) {
          clientName = project.client.displayName;
        }

        trackView(MixpanelEvents.DUPLICATE_ORDER, {
          orderId: project.itemId,
          orderType,
          element: 'three_dot_menu',
          client_name: clientName,
        });

        if (res.error) {
          trackView(MixpanelEvents.DUPLICATE_ORDER, {
            orderId: project.itemId,
            orderType,
            be_error_text: res && res.message ? res.message : res,
            element: 'three_dot_menu',
            client_name: clientName,
          });
          return;
        }
        if (projectsToProcess.length === 1)
          localStorage.setItem(
            'duplicate',
            JSON.stringify({ id: res.newOrderId, orderType: project.orderType })
          );
        if (client && type === 'singleItem') {
          props.gotoDraperyOrder(
            client.id,
            res.newOrderId,
            client.displayName,
            'setup',
            project.orderType
          );
        }
        setState({ remainingItemOrder });
      }
    }
    if (action === 'delete') {
      for (const project of projectsToProcess) {
        const res = await deleteClientProject(project);

        let orderType;

        if (project && project.orderType) {
          const type = project.orderType;

          if (type === 'custom-order') {
            orderType = 'other';
          } else if (type === 'roman-shade') {
            orderType = 'roman_shade';
          } else if (type === 'drapery-order') {
            orderType = 'drapery';
          } else {
            orderType = type;
          }
        } else {
          orderType = 'unknown';
        }

        trackView(MixpanelEvents.DELETE_ORDER, {
          orderId: project.itemId,
          orderType,
          element: 'three_dot_menu',
        });

        if (res.error) {
          trackView(MixpanelEvents.DELETE_ORDER, {
            orderId: project.itemId,
            orderType,
            be_error_text: res && res.message ? res.message : res,
            element: 'three_dot_menu',
          });
          return;
        }
      }
    }
    setState({
      checkedProjects: [],
      isModalOpen: false,
    });
    await loadProjects();
  };

  const handleProjectAction = async (
    value: string,
    type?: string,
    selectedProjectIds?: number[]
  ): Promise<void> => {
    if (!state.accountCanSeePricing && ['Duplicate'].includes(value)) {
      return;
    }
    const { checkedProjects, projectList } = state;
    const selectedIds =
      selectedProjectIds && selectedProjectIds.length
        ? Array.from(new Set([...checkedProjects, ...selectedProjectIds]))
        : checkedProjects;
    switch (value) {
      case 'Archive': {
        processItems('archive', undefined, undefined, selectedIds);
        return;
      }
      case 'Unarchive': {
        processItems('unarchive', undefined, undefined, selectedIds);
        return;
      }
      case 'Batch Edit': {
        setState({ isEditItemsModalOpen: true });
        return;
      }
      case 'Duplicate': {
        setState((prev) => ({ ...prev, duplicateLoading: true, isModalOpen: false }));
        try {
          const projectsToProcess = projectList.filter((project) =>
            selectedIds.includes(project.itemId)
          );

          // array for purchased goods duplicate
          let duplicatePurchasedGoodIds: any[] =
            projectsToProcess?.filter((i) => i.orderType === 'purchased-goods') || [];

          // rest of items for duplicate
          let restDuplicateItems = projectsToProcess?.filter(
            (i) => i.orderType !== 'purchased-goods'
          );

          if (duplicatePurchasedGoodIds?.length > 0) {
            if (duplicatePurchasedGoodIds?.length === 1) {
              props.handleShowBottomSheet(true, null);
              let payloadItem = duplicatePurchasedGoodIds?.[0];
              if (props.handlePreFill) {
                props.handlePreFill({
                  duplicate: true,
                  item: payloadItem,
                });
              }
            } else {
              const payload = {
                ids: duplicatePurchasedGoodIds?.map((i) => i.id),
              };
              await duplicatePurchasedGood(payload);
            }
          }

          if (restDuplicateItems?.length > 0) {
            const can_create_order = await userCanCreateNewOrder(props.accountId);
            const total_orders_length = await getTotalNumberCount(props.accountId);
            // const total_orders_length = await getTotalNumberCount(props.accountId);

            let order_type: string;
            // let order_limit_number: number | null | undefined;
            // let left_orders: number | undefined | null;
            let duplicate_check_case: boolean = false;
            const order_limit = await retrieveMetadata(props.accountId);
            if (
              order_limit &&
              order_limit.error &&
              order_limit.error.response &&
              order_limit.error.response.data &&
              order_limit.error.response.data.error &&
              order_limit.error.response.data.error.includes('Not Found')
            ) {
              order_type = 'error';
            } else {
              order_type = order_limit && order_limit.item_order ? 'has_limit' : 'unlimited';
            }

            if (order_type) {
              switch (order_type) {
                case 'has_limit':
                  // order_limit_number = +order_limit.item_order;
                  // left_orders = order_limit_number - total_orders_length;
                  // duplicate_check_case = left_orders >= restDuplicateItems.length;
                  const planLimit = Number(order_limit.item_order || 0);
                  const totalSoFar = Number(total_orders_length);
                  const toCreate = restDuplicateItems.length;
                  const leftInPlan = Math.max(0, planLimit - totalSoFar);
                  const deficit = Math.max(0, toCreate - leftInPlan);
                  duplicate_check_case = deficit === 0 || state.remainingItemOrder >= deficit;
                  break;
                case 'unlimited':
                  duplicate_check_case = true;
                  break;
                case 'error':
                  duplicate_check_case = false;
                  break;
                default:
                  console.log('default switch state');
              }
            }

            if ((!can_create_order && state.remainingItemOrder === 0) || !duplicate_check_case) {
              props.handleOpenSubscriptionPlanModal();
              return;
            }

            let restDuplicateItemsIds: number[] = [];
            restDuplicateItems?.forEach((i) => {
              if (i.id) restDuplicateItemsIds.push(i.id);
            });

            await processItems('duplicate', undefined, type, restDuplicateItemsIds);
          } else if (duplicatePurchasedGoodIds?.length > 0) {
            setState((prev) => {
              return {
                ...prev,
                checkedProjects: [],
                isModalOpen: false,
              };
            });
            await loadProjects();
          }

          return;
        } finally {
          setState((prev) => ({ ...prev, duplicateLoading: false }));
        }
      }
      case 'Delete': {
        processItems('delete', undefined, undefined, selectedIds);
        return;
      }
    }
  };

  const loadProjects = async () => {
    const { clientId, accountId } = props;
    const sort = state.sortValue;
    const { showArchived } = state;
    const filtersPayload = {
      rooms: state.filters.rooms.value,
      items: state.filters.items.value,
      status: state.filters.status.value,
      estimate: state.filters.estimate.value,
      invoice: state.filters.invoice.value,
      assignee: canUseRoleAssignments ? state.filters.assignee.value : [],
    };

    const phaseCtx = { client_id: clientId || undefined };
    const useParallelCache = checkGate('perf_client_page_parallel_cache');

    // Project list cache key — must include everything the server uses to
    // shape the response. Changing any of these (sort, filters, includeArchived)
    // produces a different key.
    const projectsPayload = {
      accountId: props.accountId,
      clientId,
      includeArchived: showArchived,
      sort,
      filters: filtersPayload,
    };
    const cachedProjects = useParallelCache ? getProjectListCache(clientId, projectsPayload) : null;

    // Fire the projects fetch (skip on cache hit).
    const getProjectsStopwatch = startStopwatch();
    const projectsPromise: Promise<any> = cachedProjects
      ? (logClientPhase({
          phase: 'projects.get_projects_cache_hit',
          duration_ms: 0,
          project_count:
            cachedProjects.payload && cachedProjects.payload.result
              ? cachedProjects.payload.result.length
              : 0,
          ...phaseCtx,
        }),
        Promise.resolve(cachedProjects))
      : getClientProjects(projectsPayload).then((r) => {
          const ms = getProjectsStopwatch.end();
          const list = (r && r.payload && r.payload.result) || [];
          logClientPhase({
            phase: r && r.error ? 'projects.get_projects_error' : 'projects.get_projects',
            duration_ms: ms,
            project_count: list.length,
            ...phaseCtx,
          });
          if (useParallelCache && r && !r.error) {
            setProjectListCache(clientId, projectsPayload, r);
          }
          return r;
        });

    // Fire the client fetch — in parallel when flag is on; consult the
    // cross-page client cache first when flag is on (cache hit returns
    // immediately).
    const cachedClient = useParallelCache ? getClientCacheClient(clientId) : null;
    const getClientStopwatch = startStopwatch();
    const clientPromise: Promise<any> = cachedClient
      ? (logClientPhase({ phase: 'projects.get_client_cache_hit', duration_ms: 0, ...phaseCtx }),
        Promise.resolve(cachedClient))
      : useParallelCache
        ? getClientApi({ clientId, accountId }).then((r) => {
            logClientPhase({
              phase: 'projects.get_client',
              duration_ms: getClientStopwatch.end(),
              ...phaseCtx,
            });
            if (r && !r.error) setClientCacheClient(clientId, r);
            return r;
          })
        : Promise.resolve(null);

    const getProjectsRes = await projectsPromise;
    if (getProjectsRes.error) {
      return;
    }
    const projectList: ClientDashboardModule.ClientProject[] = getProjectsRes.payload.result;

    // Legacy serial path (flag off): fetch client AFTER projects, as before.
    const res = useParallelCache
      ? await clientPromise
      : await (async () => {
          const r = await getClientApi({ clientId, accountId });
          logClientPhase({
            phase: 'projects.get_client',
            duration_ms: getClientStopwatch.end(),
            ...phaseCtx,
          });
          return r;
        })();
    if (!res || res.error) {
      return;
    }
    const client = res;
    setState({
      client,
      initialClientState: client.active,
      projectList,
      // roomList,
      parentClients: client.parentClients,
      items: getProjectsRes.payload.itemNames,
      rooms: getProjectsRes.payload.rooms,
    });
  };

  const handleGetRooms = async () => {
    const { clientId } = props;

    // Reuse the cross-page rooms cache (60s TTL). Populated by the calculator
    // page too — both pages can hit each other's cache for the same client.
    const useCache = checkGate('perf_client_page_parallel_cache');
    if (useCache) {
      const cachedRooms = getClientCacheRooms(clientId);
      if (cachedRooms) {
        setState((prev) => ({ ...prev, roomList: [...prev.roomList, ...cachedRooms] }));
        return;
      }
    }

    const getRoomListRes = await getRooms(clientId, '');
    if (getRoomListRes.error) {
      return;
    }

    const roomListArray: RoomModule.Room[] = [...state.roomList, ...getRoomListRes];

    setState((prev) => ({ ...prev, roomList: roomListArray }));
    if (useCache) {
      setClientCacheRooms(clientId, getRoomListRes);
    }
  };

  const mapSortTableToSortOptions = useCallback(
    (sortTable: SortTable): void => {
      const nextDirection: 'ASC' | 'DESC' = sortTable.position === 1 ? 'ASC' : 'DESC';
      setState((prev) => {
        if (
          prev.sortValue.field === sortTable.field &&
          prev.sortValue.direction === nextDirection
        ) {
          return prev;
        }

        return {
          ...prev,
          sortValue: {
            field: sortTable.field,
            direction: nextDirection,
          },
        };
      });
    },
    [setState]
  );

  const onAreaScroll = (e: UIEvent<HTMLDivElement>): void => {
    setState({
      areaScrollInfo: {
        scrollX: e.currentTarget.scrollLeft,
        scrollY: e.currentTarget.scrollTop,
      },
    });
  };

  const handleNotCheckedBatchRow = (id: number, project: ClientDashboardModule.ClientProject) => {
    if (project.archived) {
      return;
    }
    if (state.checkedProjects.includes(id)) {
      return;
    }
    setState({
      checkedProjects: [...state.checkedProjects, id],
    });
  };

  const onShowArchiveChange = (isShow: boolean): void => {
    setState({
      showArchived: isShow,
    });
  };

  const onOpenModal = (value: string) => {
    if (!state.accountCanSeePricing && ['Duplicate', 'DuplicateBlocked'].includes(value)) {
      return;
    }
    setState({ isModalOpen: true, value });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const openPo = String(params.get('openPo') || '').trim();

      if (openPo) {
        handleLinkedPO(openPo, 'pos');
      }
    }
  }, []);

  useEffect(() => {
    setRoleColumnVisibility((prev) => {
      if (!canUseRoleAssignments || roleAssignmentColumns.length === 0) {
        return {};
      }
      const next: Record<number, boolean> = {};
      roleAssignmentColumns.forEach((role) => {
        next[role.id] = prev[role.id] !== false;
      });
      return next;
    });
  }, [canUseRoleAssignments, roleAssignmentColumns]);

  useEffect(() => {
    void componentDidMount();
    return () => {
      componentWillUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const timeoutId = window.setTimeout(() => {
      setState({ displayContent: true });
    }, 100);
    return () => {
      window.clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    void loadRoleAssignmentConfig();
  }, [loadRoleAssignmentConfig]);

  useEffect(() => {
    componentDidUpdate(prevPropsRef.current, prevStateRef.current);
    prevPropsRef.current = props;
    prevStateRef.current = state;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  return render();
};

function mapStateToProps(state: RootState, ownProps: ClientOwnProps): ClientProps {
  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
  };
}

export const ClientContainer = connect(mapStateToProps)(Client);
